"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4239],{

/***/ 30554:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34885);
var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

function SvgCartForButton(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zM1 2v2h2l3.6 7.59-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h12v-2H7.42c-.14 0-.25-.11-.25-.25l.03-.12.9-1.63h7.45c.75 0 1.41-.41 1.75-1.03l3.58-6.49A1.003 1.003 0 0020 4H5.21l-.94-2H1zm16 16c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2z"
  })), _path2 || (_path2 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  })));
}
/* harmony default export */ __webpack_exports__["Z"] = (SvgCartForButton);

/***/ }),

/***/ 24132:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(__webpack_require__(13027));
var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(2302));
var _agent = __webpack_require__(37642);
var _createParametrizedUrl = _interopRequireDefault(__webpack_require__(18934));
var _mapCategory = _interopRequireDefault(__webpack_require__(7543));
var fetcher = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(categoryId, lang) {
    var categoryData;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (categoryId) {
              _context.next = 2;
              break;
            }
            return _context.abrupt("return");
          case 2:
            _context.next = 4;
            return _agent.requests.get((0, _createParametrizedUrl["default"])(__webpack_require__.g.__appConfig__.categoryUrl, {
              id: categoryId
            }), true, null, lang);
          case 4:
            categoryData = _context.sent;
            return _context.abrupt("return", (0, _mapCategory["default"])(categoryData));
          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return function fetcher(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
var _default = fetcher;
exports["default"] = _default;

/***/ }),

/***/ 99906:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(7125);
__webpack_unused_export__ = ({
  value: true
});
Object.defineProperty(exports, "b5", ({
  enumerable: true,
  get: function get() {
    return _useCategory["default"];
  }
}));
Object.defineProperty(exports, "_i", ({
  enumerable: true,
  get: function get() {
    return _fetcher["default"];
  }
}));
__webpack_unused_export__ = void 0;
var _useCategory = _interopRequireDefault(__webpack_require__(91839));
var _fetcher = _interopRequireDefault(__webpack_require__(24132));
var _default = _useCategory["default"];
__webpack_unused_export__ = _default;

/***/ }),

/***/ 91839:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _fetcher = _interopRequireDefault(__webpack_require__(24132));
var _swr = _interopRequireDefault(__webpack_require__(56157));
var _LanguageProvider = __webpack_require__(8989);
var useCategory = function useCategory(categoryId, fetchedCategories) {
  var _useLanguage = (0, _LanguageProvider.useLanguage)(),
    language = _useLanguage.language;
  return (0, _swr["default"])([categoryId, language, "useCategory"], _fetcher["default"], {
    initialData: fetchedCategories
  });
};
var _default = useCategory;
exports["default"] = _default;

/***/ }),

/***/ 14546:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(__webpack_require__(13027));
var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(2302));
var _mapProductDataNew = _interopRequireDefault(__webpack_require__(69729));
var _agent = __webpack_require__(37642);
var _createSearchUrl = __webpack_require__(8371);
var fetcher = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(collectionId) {
    var pageSize,
      language,
      productsFromCollectionMapped,
      productsFromCollection,
      _args = arguments;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            pageSize = _args.length > 1 && _args[1] !== undefined ? _args[1] : 10;
            language = _args.length > 2 ? _args[2] : undefined;
            productsFromCollectionMapped = [];
            if (collectionId) {
              _context.next = 5;
              break;
            }
            return _context.abrupt("return", productsFromCollectionMapped);
          case 5:
            _context.prev = 5;
            _context.next = 8;
            return _agent.requests.get((0, _createSearchUrl.createSearchUrl)("/products", [{
              field: "dajar_collection",
              condition_type: "eq",
              value: collectionId,
              connector: _createSearchUrl.CONNECTORS.AND
            }, {
              field: "type_id",
              value: "simple",
              connector: _createSearchUrl.CONNECTORS.AND
            }, {
              field: "visibility",
              condition_type: "in",
              value: [2, 4],
              connector: _createSearchUrl.CONNECTORS.AND
            }, {
              pageSize: pageSize
            }]), __webpack_require__.g.__appConfig__.elasticEnabled, null, language);
          case 8:
            productsFromCollection = _context.sent;
            if (productsFromCollection.total_count > 0) {
              productsFromCollectionMapped = (0, _mapProductDataNew["default"])(productsFromCollection.items);
            } else {
              productsFromCollectionMapped = [];
            }
            _context.next = 16;
            break;
          case 12:
            _context.prev = 12;
            _context.t0 = _context["catch"](5);
            console.log("There was an error while fetching products from collection ".concat(collectionId));
            productsFromCollectionMapped = [];
          case 16:
            return _context.abrupt("return", productsFromCollectionMapped);
          case 17:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[5, 12]]);
  }));
  return function fetcher(_x) {
    return _ref.apply(this, arguments);
  };
}();
var _default = fetcher;
exports["default"] = _default;

/***/ }),

/***/ 41410:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(7125);
__webpack_unused_export__ = ({
  value: true
});
Object.defineProperty(exports, "ie", ({
  enumerable: true,
  get: function get() {
    return _useProductsFromCollection["default"];
  }
}));
Object.defineProperty(exports, "_i", ({
  enumerable: true,
  get: function get() {
    return _fetcher["default"];
  }
}));
__webpack_unused_export__ = void 0;
var _useProductsFromCollection = _interopRequireDefault(__webpack_require__(27898));
var _fetcher = _interopRequireDefault(__webpack_require__(14546));
var _default = _useProductsFromCollection["default"];
__webpack_unused_export__ = _default;

/***/ }),

/***/ 27898:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _swr = _interopRequireDefault(__webpack_require__(56157));
var _fetcher = _interopRequireDefault(__webpack_require__(14546));
var _LanguageProvider = __webpack_require__(8989);
var useProductsFromCollection = function useProductsFromCollection(collectionId, pageSize, fetchedCollection, page) {
  var _useLanguage = (0, _LanguageProvider.useLanguage)(),
    language = _useLanguage.language;
  return (0, _swr["default"])([collectionId, pageSize, language, page, "useProductsFromCollection"], _fetcher["default"], {
    initialData: fetchedCollection
  });
};
var _default = useProductsFromCollection;
exports["default"] = _default;

/***/ }),

/***/ 49412:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _react = _interopRequireDefault(__webpack_require__(34885));
var _priceFormat = _interopRequireDefault(__webpack_require__(93340));
var _CurrencyProvider = __webpack_require__(38073);
function usePriceFormatter() {
  var _useCurrency = (0, _CurrencyProvider.useCurrency)(),
    currency = _useCurrency.currency;
  var currencySymbol = currency === null || currency === void 0 ? void 0 : currency.symbol;
  return {
    currencySymbol: currencySymbol,
    priceWithSymbol: function priceWithSymbol(price) {
      return (0, _priceFormat["default"])(price) + " " + currencySymbol;
    }
  };
}
var _default = usePriceFormatter;
exports["default"] = _default;

/***/ }),

/***/ 71855:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.ProductHeadOptionsContextProvider = exports.useProductHeadOptions = exports["default"] = void 0;
var _react = _interopRequireWildcard(__webpack_require__(34885));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) { "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); } return f; })(e, t); }
var __jsx = _react["default"].createElement;
var ProductHeadOptionsContext = /*#__PURE__*/_react["default"].createContext();
var ProductHeadOptionsContextProvider = function ProductHeadOptionsContextProvider(props) {
  var _useState = (0, _react.useState)(null),
    activeProduct = _useState[0],
    setActiveProduct = _useState[1];
  var _useState2 = (0, _react.useState)(null),
    activePicker = _useState2[0],
    setActivePicker = _useState2[1];
  var updateActiveProduct = function updateActiveProduct(product) {
    setActiveProduct(product);
  };
  var updateActivePicker = function updateActivePicker(product) {
    setActivePicker(product);
  };
  return __jsx(ProductHeadOptionsContext.Provider, {
    value: {
      updateActiveProduct: updateActiveProduct,
      activeProduct: activeProduct,
      activePicker: activePicker,
      updateActivePicker: updateActivePicker
    }
  }, props.children);
};
exports.ProductHeadOptionsContextProvider = ProductHeadOptionsContextProvider;
var useProductHeadOptions = function useProductHeadOptions() {
  return (0, _react.useContext)(ProductHeadOptionsContext);
};
exports.useProductHeadOptions = useProductHeadOptions;
var _default = ProductHeadOptionsContextProvider;
exports["default"] = _default;

/***/ }),

/***/ 98201:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.useScrollableStack = useScrollableStack;
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(__webpack_require__(6780));
var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(88450));
var _defineProperty2 = _interopRequireDefault(__webpack_require__(20389));
var _react = _interopRequireWildcard(__webpack_require__(34885));
var _core = __webpack_require__(79329);
var _Box = _interopRequireDefault(__webpack_require__(40300));
var _responsiveHelpers = __webpack_require__(96775);
var _useHover = _interopRequireDefault(__webpack_require__(68854));
var _animatedScrollTo = _interopRequireDefault(__webpack_require__(34948));
var _excluded = ["sx", "children", "controller", "previousButton", "nextButton", "gap", "align", "innerMargin", "itemSize", "itemsVisible", "scrollableContainerRef"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) { "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); } return f; })(e, t); }
var __jsx = _react["default"].createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function easeOutExpo(x) {
  return x === 1 ? 1 : 1 - Math.pow(2, -10 * x);
}
function getNextPos(scrollableContainerRef, spacerRef, itemRefs) {
  var direction = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
  var spacerWidth = spacerRef.current.getBoundingClientRect().width;
  var containerRect = scrollableContainerRef.current.getBoundingClientRect();
  var containerWidth = containerRect.width - spacerWidth * 2;
  var closestItem;
  var closestDiff = 999999;
  for (var i = 0; i < itemRefs.current.length; i++) {
    var item = itemRefs.current[i];
    var left = item.current.getBoundingClientRect().left - containerRect.left;
    var diff = Math.abs(left + containerWidth * direction - spacerWidth);
    if (diff < closestDiff) {
      closestItem = item.current;
      closestDiff = diff;
    }
  }
  var pos = scrollableContainerRef.current.scrollLeft + (closestItem.getBoundingClientRect().left - containerRect.left - spacerWidth);

  // snap to boundaries (1px problem)
  pos = Math.ceil(pos);
  if (Math.abs(pos) < 3) {
    pos = 0;
  }
  return pos;
}
function _scrollTo(container, pos) {
  container.style.willChange = "scroll-position";
  (0, _animatedScrollTo["default"])([pos, null], {
    elementToScroll: container,
    easing: easeOutExpo,
    minDuration: 500,
    maxDuration: 500
  }).then(function () {
    container.style.willChange = "auto";
  });
}

/**
 * Helper component placing components next to each other with gutter.
 *
 * Gutter can be responsive but items layout can not. So it's usable ONLY if on all resolutions items will be next to each other and won't wrap.
 */
function useScrollableStack(props) {
  var scrollableContainerRef = (0, _react.useRef)(null);
  var floatingElementRef = (0, _react.useRef)(null);
  var _useState = (0, _react.useState)(true),
    isAtStart = _useState[0],
    setIsAtStart = _useState[1];
  var _useState2 = (0, _react.useState)(true),
    isAtEnd = _useState2[0],
    setIsAtEnd = _useState2[1];
  var itemRefs = (0, _react.useRef)(null);
  if (!itemRefs.current || itemRefs.current.length < props.length || itemRefs.current.length > props.length) {
    itemRefs.current = [];
    for (var i = 0; i < props.length; i++) {
      itemRefs.current.push(/*#__PURE__*/_react["default"].createRef());
    }
  }
  (0, _react.useEffect)(function () {
    _scrollTo(scrollableContainerRef.current, 0);
    setIsAtStart(true);
    setIsAtEnd(false);
  }, [itemRefs.current]);
  var spacerRef = (0, _react.useRef)(null);
  var setFloatingElementIndex = function setFloatingElementIndex(n) {
    if (!floatingElementRef.current) {
      return;
    }
    if (typeof props.length !== "number") {
      throw new Error("You're must pass 'length' parameter to useScrollableStack in order to make it work with floating element!!!");
    }
    var offsetLeft;
    var width;
    if (n === null) {
      offsetLeft = 0;
      width = 0;
    } else {
      offsetLeft = itemRefs.current[n].current.offsetLeft;
      width = itemRefs.current[n].current.clientWidth;
    }
    floatingElementRef.current.style.transform = "translateX(".concat(offsetLeft, "px)");
    floatingElementRef.current.style.width = "".concat(width, "px");
  };
  (0, _react.useEffect)(function () {
    setFloatingElementIndex(typeof props.initialFloatingElementIndex === "number" ? props.initialFloatingElementIndex : 0);
    setTimeout(function () {
      if (floatingElementRef.current) {
        floatingElementRef.current.style.transition = "all .15s ease-out";
      }
    }, 500);
  }, []);
  (0, _react.useEffect)(function () {
    var elem = scrollableContainerRef.current;
    var listener = function listener() {
      var isStart = elem.scrollLeft <= 0;
      var isEnd = parseInt(elem.scrollWidth - elem.scrollLeft) <= elem.clientWidth;
      setIsAtStart(isStart);
      setIsAtEnd(isEnd);
    };
    listener();
    elem.addEventListener("scroll", listener, {
      passive: true
    });
    return function () {
      elem.removeEventListener("scroll", listener);
    };
  }, [itemRefs.current]);
  var ret = {
    scrollTo: function scrollTo(pos) {
      _scrollTo(scrollableContainerRef.current, pos);
    },
    isAtStart: isAtStart,
    isAtEnd: isAtEnd
  };

  // const currentContainerWidth = currentValue(padding) * 2;
  var previousButtonProps = {
    onClick: function onClick() {
      var newLeftPos = getNextPos(scrollableContainerRef, spacerRef, itemRefs, 1);
      _scrollTo(scrollableContainerRef.current, newLeftPos);
    }
  };
  var nextButtonProps = {
    onClick: function onClick() {
      var newLeftPos = getNextPos(scrollableContainerRef, spacerRef, itemRefs, -1);
      _scrollTo(scrollableContainerRef.current, newLeftPos);
    }
  };
  return _objectSpread(_objectSpread({}, ret), {}, {
    scrollableContainerRef: scrollableContainerRef,
    itemRefs: itemRefs.current,
    floatingElementRef: floatingElementRef,
    spacerRef: spacerRef,
    setFloatingElementIndex: setFloatingElementIndex,
    previousButtonProps: previousButtonProps,
    nextButtonProps: nextButtonProps
  });
}
function ScrollableStack(props) {
  var _controller, _controller$scrollabl, _controller$scrollabl2;
  var sx = props.sx,
    children = props.children,
    controller = props.controller,
    previousButton = props.previousButton,
    nextButton = props.nextButton,
    gap = props.gap,
    align = props.align,
    innerMargin = props.innerMargin,
    itemSize = props.itemSize,
    itemsVisible = props.itemsVisible,
    scrollableContainerRef = props.scrollableContainerRef,
    restProps = (0, _objectWithoutProperties2["default"])(props, _excluded);
  var _splitSx = (0, _core.splitSx)(sx),
    _splitSx2 = (0, _slicedToArray2["default"])(_splitSx, 2),
    css = _splitSx2[0],
    customSx = _splitSx2[1];
  var rootRef = (0, _react.useRef)(null);
  var isRootHovered = (0, _useHover["default"])(rootRef);
  gap = gap || customSx.$gap || 0;
  align = align || customSx.$align || "left";
  var padding = innerMargin || customSx.$innerMargin || 0;
  if (!controller) {
    controller = useScrollableStack(_objectSpread(_objectSpread({}, props), {}, {
      length: props.children.length
    }));
  }
  var itemProps;

  // check if should show buttons
  var showButtons = true;
  var containerWidth = (_controller = controller) === null || _controller === void 0 ? void 0 : (_controller$scrollabl = _controller.scrollableContainerRef) === null || _controller$scrollabl === void 0 ? void 0 : (_controller$scrollabl2 = _controller$scrollabl.current) === null || _controller$scrollabl2 === void 0 ? void 0 : _controller$scrollabl2.getBoundingClientRect().width;
  if (containerWidth) {
    showButtons = containerWidth - (sx.$itemSize + sx.$gap) * props.children.length < 0;
  }
  itemSize = itemSize || customSx.$itemSize;
  itemsVisible = itemsVisible || customSx.$itemsVisible;
  if (itemSize) {
    itemProps = {
      width: itemSize
    };
  } else if (itemsVisible) {
    // TODO: unify responsive values arithmetics

    (0, _core.responsiveValueForEach)(align, function (val) {
      if (val !== "left") {
        console.warn("Warning: ScrollableStack uses $itemsVisible + $align, this behaviour is not allowed. If you want to use $align, please use $itemSize property or go with natural item widths.");
      }
    });
    align = "left";
    var itemsVisibleMap = (0, _core.responsiveValueToRangeMap)(itemsVisible);
    var paddingRs = (0, _core.responsiveValueToResponsiveSize)(padding);
    var gapRs = (0, _core.responsiveValueToResponsiveSize)(gap);
    var multiplier = {};
    itemsVisibleMap.forEach(function (itemsVisible, range) {
      multiplier[range.from] = (itemsVisible - 1) / itemsVisible;
    });
    var base = (0, _responsiveHelpers.rs)("100%");
    // if (!props.itemsVisibleIncludeMargins) {
    base = base.subtract(paddingRs).subtract(paddingRs);
    // }

    var size = base.divide(itemsVisibleMap).subtract(gapRs.multiply(multiplier));
    itemProps = size.cssObject("width");
  }
  var floatingElement;
  if (customSx.$floatingElement) {
    floatingElement = (0, _core.createElement)((0, _core.getElementSpec)(customSx.$floatingElement, {
      __type: _Box["default"],
      position: "absolute",
      width: 0,
      zIndex: customSx.$floatingElementUnder ? -1 : 1,
      bottom: 0,
      left: 0
    }, {}), {
      _ref: controller.floatingElementRef
    });
  }

  /**
   * Inner container styles
   */
  var innerContainerStyles = {
    width: (0, _core.responsiveValueMap)(align, function (x) {
      return x === "left" ? "100%" : undefined;
    }),
    ml: (0, _core.responsiveValueMap)(align, function (x) {
      return x === "center" || x === "right" ? "auto" : "initial";
    }),
    mr: (0, _core.responsiveValueMap)(align, function (x) {
      return x === "center" || x === "left" ? "auto" : "initial";
    })
  };
  var childrenArray = _react["default"].Children.toArray(children);

  // TODO: floating line!!! (rect) => ...

  /**
   * Buttons
   */
  if (previousButton) {
    if (typeof previousButton === "function") {
      previousButton = previousButton(_objectSpread(_objectSpread({}, controller), {}, {
        isParentHovered: isRootHovered
      }));
    }
    if (/*#__PURE__*/_react["default"].isValidElement(previousButton)) {
      previousButton = {
        button: previousButton
      };
    }
    previousButton.offset = previousButton.offset || 0;
    previousButton.hideOnTouch = previousButton.hideOnTouch || true;
    if (typeof previousButton.button === "function") {
      previousButton.button = previousButton.button({
        buttonProps: controller.previousButtonProps
      });
    }
  }
  if (nextButton) {
    if (typeof nextButton === "function") {
      nextButton = nextButton(_objectSpread(_objectSpread({}, controller), {}, {
        isParentHovered: isRootHovered
      }));
    }
    if (/*#__PURE__*/_react["default"].isValidElement(nextButton)) {
      nextButton = {
        button: nextButton
      };
    }
    nextButton.offset = nextButton.offset || 0;
    nextButton.hideOnTouch = nextButton.hideOnTouch || true;
    if (typeof nextButton.button === "function") {
      nextButton.button = nextButton.button({
        buttonProps: controller.nextButtonProps
      });
    }
  }
  return __jsx(_Box["default"], {
    sx: _objectSpread({
      position: "relative"
    }, css),
    _ref: rootRef
  }, __jsx(_Box["default"], {
    sx: [{
      position: "relative",
      display: "flex",
      height: "100%",
      minHeight: "inherit",
      overflowX: "auto",
      "::-webkit-scrollbar": {
        display: "none"
      },
      scrollbarWidth: "none"
    }],
    _ref: controller.scrollableContainerRef
  }, __jsx(_Box["default"], {
    sx: _objectSpread({
      display: "flex",
      flexDirection: "row",
      flexWrap: "nowrap"
    }, innerContainerStyles)
  }, floatingElement, __jsx(_Box["default"], {
    sx: {
      position: "relative",
      flexGrow: 0,
      flexShrink: 0,
      flexBasis: padding,
      zIndex: 0
    },
    ref: controller.spacerRef
  }), childrenArray.map(function (child, index) {
    return __jsx(_Box["default"], {
      sx: _objectSpread({
        position: "relative",
        marginRight: index === childrenArray.length - 1 ? 0 : gap,
        flexGrow: 0,
        flexShrink: 0
      }, itemProps),
      key: child.key,
      _ref: controller.itemRefs[index]
    }, child);
  }), __jsx(_Box["default"], {
    sx: {
      position: "relative",
      flexGrow: 0,
      flexShrink: 0,
      flexBasis: padding
    }
  }))), previousButton && __jsx(_Box["default"], {
    sx: {
      position: "absolute",
      left: padding,
      top: 0,
      height: "100%",
      display: showButtons ? "flex" : "none",
      alignItems: "center"
    }
  }, __jsx(_Box["default"], {
    sx: _objectSpread({
      position: "relative",
      left: previousButton.offset
    }, previousButton.hideOnTouch ? {
      "@media not all and (pointer: fine)": {
        display: "none"
      }
    } : {})
  }, /*#__PURE__*/_react["default"].cloneElement(previousButton.button, controller.previousButtonProps))), nextButton && __jsx(_Box["default"], {
    sx: {
      position: "absolute",
      right: padding,
      top: 0,
      height: "100%",
      display: showButtons ? "flex" : "none",
      alignItems: "center"
    }
  }, __jsx(_Box["default"], {
    sx: _objectSpread({
      position: "relative",
      right: nextButton.offset
    }, nextButton.hideOnTouch ? {
      "@media not all and (pointer: fine)": {
        display: "none"
      }
    } : {})
  }, /*#__PURE__*/_react["default"].cloneElement(nextButton.button, controller.nextButtonProps))));
}
var _default = ScrollableStack;
exports["default"] = _default;

/***/ }),

/***/ 57689:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.useSelectScrollableStack = useSelectScrollableStack;
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(__webpack_require__(20389));
var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(88450));
var _react = _interopRequireWildcard(__webpack_require__(34885));
var _SelectInline = __webpack_require__(71070);
var _useScrollableStack = _interopRequireWildcard(__webpack_require__(98201));
var _excluded = ["scrollableStack"],
  _excluded2 = ["sx", "controller", "children"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) { "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); } return f; })(e, t); }
var __jsx = _react["default"].createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function useSelectScrollableStack() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _props$scrollableStac = props.scrollableStack,
    scrollableStack = _props$scrollableStac === void 0 ? {} : _props$scrollableStac,
    selectInlineProps = (0, _objectWithoutProperties2["default"])(props, _excluded);
  var selectInlineController;
  var scrollableStackController;
  selectInlineController = (0, _SelectInline.useSelectInline)(selectInlineProps);
  (0, _react.useEffect)(function () {
    scrollableStackController.setFloatingElementIndex(selectInlineController.selectedIndex);
  }, [selectInlineController.selectedIndex]);
  scrollableStackController = (0, _useScrollableStack.useScrollableStack)(_objectSpread(_objectSpread({}, scrollableStack), {}, {
    length: props.options.length,
    initialFloatingElementIndex: selectInlineController.selectedIndex
  }));
  return _objectSpread(_objectSpread({}, selectInlineController), {}, {
    scrollableStack: scrollableStackController
  });
}
function SelectScrollableStack(props) {
  var sx = props.sx,
    controller = props.controller,
    children = props.children,
    restProps = (0, _objectWithoutProperties2["default"])(props, _excluded2);
  if (!controller) {
    controller = useSelectScrollableStack(_objectSpread({}, props));
  }
  var selectInlineController = _objectSpread({}, controller);
  delete selectInlineController.scrollableStack;
  var scrollableStackController = controller.scrollableStack;
  var itemElement = _react["default"].Children.only(children);
  children = selectInlineController.selectableProps.map(function (props) {
    return /*#__PURE__*/_react["default"].cloneElement(itemElement, props);
  });
  return __jsx(_useScrollableStack["default"], {
    nextButton: props.nextButton,
    previousButton: props.previousButton,
    controller: scrollableStackController,
    sx: sx
  }, children);
}
var _default = SelectScrollableStack;
exports["default"] = _default;

/***/ }),

/***/ 22631:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(__webpack_require__(13027));
var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(2302));
var _cache = __webpack_require__(75800);
var _prismicHelper = __webpack_require__(63981);
var _brandInfo = _interopRequireDefault(__webpack_require__(21052));
var _prismicErrorHandle = _interopRequireDefault(__webpack_require__(38115));
var filename = __webpack_require__.g.__appConfig__.prismicBrandInfo;
var fetcher = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(uid, language) {
    var _yield$getLanguage, cacheFileExist, cachedRequest, lang, cacheFilePath, response, mappedInfo, _yield$getLanguage2, _cacheFileExist, _cachedRequest;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (uid) {
              _context.next = 2;
              break;
            }
            return _context.abrupt("return", false);
          case 2:
            _context.next = 4;
            return (0, _prismicHelper.getLanguage)({
              language: language,
              filename: "".concat(filename, "-").concat(uid)
            });
          case 4:
            _yield$getLanguage = _context.sent;
            cacheFileExist = _yield$getLanguage.cacheFileExist;
            cachedRequest = _yield$getLanguage.cachedRequest;
            lang = _yield$getLanguage.lang;
            cacheFilePath = _yield$getLanguage.cacheFilePath;
            if (!cacheFileExist) {
              _context.next = 11;
              break;
            }
            return _context.abrupt("return", cachedRequest);
          case 11:
            _context.prev = 11;
            _context.next = 14;
            return (0, _prismicHelper.getResponsePrismicByUID)({
              type: filename,
              uid: uid,
              lang: lang
            });
          case 14:
            response = _context.sent;
            mappedInfo = (0, _brandInfo["default"])(response);
            _context.next = 18;
            return (0, _cache.saveCacheFile)({
              cacheFilePath: cacheFilePath,
              filenameCategoryCache: "".concat(filename, "-").concat(uid, ".json"),
              result: mappedInfo
            });
          case 18:
            return _context.abrupt("return", mappedInfo);
          case 21:
            _context.prev = 21;
            _context.t0 = _context["catch"](11);
            _context.next = 25;
            return (0, _prismicHelper.getLanguage)({
              language: language,
              filename: filename
            });
          case 25:
            _yield$getLanguage2 = _context.sent;
            _cacheFileExist = _yield$getLanguage2.cacheFileExist;
            _cachedRequest = _yield$getLanguage2.cachedRequest;
            if (!_cacheFileExist) {
              _context.next = 30;
              break;
            }
            return _context.abrupt("return", _cachedRequest);
          case 30:
            return _context.abrupt("return", (0, _prismicErrorHandle["default"])(_context.t0, "Prismic - brand info uid: ".concat(uid, " - ").concat(_context.t0)));
          case 31:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[11, 21]]);
  }));
  return function fetcher(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
var _default = fetcher;
exports["default"] = _default;

/***/ }),

/***/ 43000:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(7125);
__webpack_unused_export__ = ({
  value: true
});
Object.defineProperty(exports, "yF", ({
  enumerable: true,
  get: function get() {
    return _usePrismicBrandInfo["default"];
  }
}));
Object.defineProperty(exports, "_i", ({
  enumerable: true,
  get: function get() {
    return _fetcher["default"];
  }
}));
var _usePrismicBrandInfo = _interopRequireDefault(__webpack_require__(34219));
var _fetcher = _interopRequireDefault(__webpack_require__(22631));

/***/ }),

/***/ 34219:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _fetcher = _interopRequireDefault(__webpack_require__(22631));
var _swr = _interopRequireDefault(__webpack_require__(56157));
var usePrismicBrandInfo = function usePrismicBrandInfo(uid, language, fetchedPrismicContent) {
  return (0, _swr["default"])([uid, language, "usePrismicBrandInfo"], _fetcher["default"], {
    initialData: fetchedPrismicContent
  });
};
var _default = usePrismicBrandInfo;
exports["default"] = _default;

/***/ }),

/***/ 97445:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(__webpack_require__(13027));
var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(2302));
var _cache = __webpack_require__(75800);
var _prismicHelper = __webpack_require__(63981);
var _collectionInfo = _interopRequireDefault(__webpack_require__(95842));
var _prismicErrorHandle = _interopRequireDefault(__webpack_require__(38115));
var filename = "collectioninfo";
var fetcher = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(uid, language) {
    var _yield$getLanguage, cacheFileExist, cachedRequest, lang, cacheFilePath, response, mappedInfo, _yield$getLanguage2, _cacheFileExist, _cachedRequest;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (uid) {
              _context.next = 2;
              break;
            }
            return _context.abrupt("return", false);
          case 2:
            _context.next = 4;
            return (0, _prismicHelper.getLanguage)({
              language: language,
              filename: "".concat(filename, "-").concat(uid)
            });
          case 4:
            _yield$getLanguage = _context.sent;
            cacheFileExist = _yield$getLanguage.cacheFileExist;
            cachedRequest = _yield$getLanguage.cachedRequest;
            lang = _yield$getLanguage.lang;
            cacheFilePath = _yield$getLanguage.cacheFilePath;
            if (!cacheFileExist) {
              _context.next = 11;
              break;
            }
            return _context.abrupt("return", cachedRequest);
          case 11:
            _context.prev = 11;
            _context.next = 14;
            return (0, _prismicHelper.getResponsePrismicByUID)({
              type: filename,
              uid: uid,
              lang: lang
            });
          case 14:
            response = _context.sent;
            mappedInfo = (0, _collectionInfo["default"])(response);
            _context.next = 18;
            return (0, _cache.saveCacheFile)({
              cacheFilePath: cacheFilePath,
              filenameCategoryCache: "".concat(filename, "-").concat(uid, ".json"),
              result: mappedInfo
            });
          case 18:
            return _context.abrupt("return", mappedInfo);
          case 21:
            _context.prev = 21;
            _context.t0 = _context["catch"](11);
            _context.next = 25;
            return (0, _prismicHelper.getLanguage)({
              language: language,
              filename: filename
            });
          case 25:
            _yield$getLanguage2 = _context.sent;
            _cacheFileExist = _yield$getLanguage2.cacheFileExist;
            _cachedRequest = _yield$getLanguage2.cachedRequest;
            if (!_cacheFileExist) {
              _context.next = 30;
              break;
            }
            return _context.abrupt("return", _cachedRequest);
          case 30:
            return _context.abrupt("return", (0, _prismicErrorHandle["default"])(_context.t0, "Prismic - collection info uid: ".concat(uid, " - ").concat(_context.t0)));
          case 31:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[11, 21]]);
  }));
  return function fetcher(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
var _default = fetcher;
exports["default"] = _default;

/***/ }),

/***/ 11180:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(7125);
__webpack_unused_export__ = ({
  value: true
});
Object.defineProperty(exports, "W2", ({
  enumerable: true,
  get: function get() {
    return _usePrismicCollectionInfo["default"];
  }
}));
Object.defineProperty(exports, "_i", ({
  enumerable: true,
  get: function get() {
    return _fetcher["default"];
  }
}));
var _usePrismicCollectionInfo = _interopRequireDefault(__webpack_require__(63557));
var _fetcher = _interopRequireDefault(__webpack_require__(97445));

/***/ }),

/***/ 63557:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _fetcher = _interopRequireDefault(__webpack_require__(97445));
var _swr = _interopRequireDefault(__webpack_require__(56157));
var usePrismicCollectionInfo = function usePrismicCollectionInfo(uid, language, fetchedPrismicContent) {
  return (0, _swr["default"])([uid, language, "usePrismicCollectionInfo"], _fetcher["default"], {
    initialData: fetchedPrismicContent
  });
};
var _default = usePrismicCollectionInfo;
exports["default"] = _default;

/***/ }),

/***/ 59170:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(7125);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _react = _interopRequireDefault(__webpack_require__(34885));
var _Box = _interopRequireDefault(__webpack_require__(40300));
var _prismicReactjs = __webpack_require__(56410);
var __jsx = _react["default"].createElement;
var BrandInfo = function BrandInfo(props) {
  var title = props.title,
    description = props.description,
    icon = props.icon;
  return __jsx(_Box["default"], {
    sx: {
      minHeight: "100%",
      display: "flex",
      flexDirection: "column"
    }
  }, icon && __jsx(_Box["default"], {
    sx: {
      width: "100%",
      mb: "s10"
    }
  }, __jsx(_Box["default"], {
    sx: {
      maxWidth: 300,
      m: "0 auto"
    },
    dangerouslySetInnerHTML: {
      __html: icon
    }
  })), title && __jsx(_Box["default"], {
    sx: {
      font: "heading3",
      textAlign: "left",
      color: "main",
      pb: "s8"
    }
  }, title), description && __jsx(_Box["default"], {
    sx: {
      font: "base_sans",
      color: "main",
      a: {
        color: "main"
      }
    }
  }, _prismicReactjs.RichText.render(description)));
};
var _default = BrandInfo;
exports.Z = _default;

/***/ }),

/***/ 3343:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(7125);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _react = _interopRequireDefault(__webpack_require__(34885));
var _LinkRaw = _interopRequireDefault(__webpack_require__(88244));
var _Box = _interopRequireDefault(__webpack_require__(40300));
var _Image = _interopRequireDefault(__webpack_require__(90451));
var _RouteContext = __webpack_require__(73157);
var __jsx = _react["default"].createElement;
var defaultProps = {
  imageBorderRadius: "0px",
  titleAs: "p",
  infoOnly: false,
  font: "heading3",
  titleMargin: null,
  squareImage: false
};
var CardWithLabel = function CardWithLabel(props) {
  var image = props.image,
    name = props.name,
    params = props.params,
    href = props.href,
    _props$titleAs = props.titleAs,
    titleAs = _props$titleAs === void 0 ? defaultProps.titleAs : _props$titleAs,
    _props$imageBorderRad = props.imageBorderRadius,
    imageBorderRadius = _props$imageBorderRad === void 0 ? defaultProps.imageBorderRadius : _props$imageBorderRad,
    _props$infoOnly = props.infoOnly,
    infoOnly = _props$infoOnly === void 0 ? defaultProps.infoOnly : _props$infoOnly,
    _props$font = props.font,
    font = _props$font === void 0 ? defaultProps.font : _props$font,
    _props$titleMargin = props.titleMargin,
    titleMargin = _props$titleMargin === void 0 ? defaultProps.titleMargin : _props$titleMargin,
    _props$squareImage = props.squareImage,
    squareImage = _props$squareImage === void 0 ? defaultProps.squareImage : _props$squareImage;
  var _useRouteContext = (0, _RouteContext.useRouteContext)(),
    Link = _useRouteContext.Link;
  var content = __jsx(_Box["default"], null, __jsx(_Image["default"], {
    sx: {
      marginBottom: "s6",
      borderRadius: imageBorderRadius,
      mb: titleMargin !== null && titleMargin !== void 0 ? titleMargin : 0
    },
    image: image,
    sizes: "420px"
  }), __jsx(_Box["default"], {
    as: titleAs,
    sx: {
      textAlign: "left",
      font: font,
      color: "main"
    }
  }, name));
  return infoOnly ? __jsx(_Box["default"], null, content) : __jsx(Link, {
    route: href,
    params: {
      url: (params === null || params === void 0 ? void 0 : params.url.indexOf("/")) === 0 ? params.url.replace("/", "") : params.url
    }
  }, __jsx(_LinkRaw["default"], {
    title: name
  }, content));
};
var _default = CardWithLabel;
exports.Z = _default;

/***/ }),

/***/ 53171:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _react = _interopRequireDefault(__webpack_require__(34885));
var _Clock = _interopRequireDefault(__webpack_require__(74970));
var _ProductsCounter = _interopRequireDefault(__webpack_require__(269));
var _Box = _interopRequireDefault(__webpack_require__(40300));
var __jsx = _react["default"].createElement;
var HitProductPage = function HitProductPage() {
  return __jsx(_Box["default"], {
    sx: {
      width: "100%",
      height: 260,
      color: "white",
      backgroundColor: "main",
      display: "flex",
      px: "s11",
      marginBottom: "s7"
    }
  }, __jsx(_Box["default"], {
    sx: {
      width: "100%",
      flex: "display",
      justifyContent: "center",
      alignItems: "center",
      textAlign: "center",
      mt: "s8"
    }
  }, __jsx(_Clock["default"], null), __jsx(_ProductsCounter["default"], {
    progressActive: true
  })));
};
var _default = HitProductPage;
exports["default"] = _default;

/***/ }),

/***/ 97530:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.useImageSlider = useImageSlider;
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(__webpack_require__(20389));
var _slicedToArray2 = _interopRequireDefault(__webpack_require__(6780));
var _Image = _interopRequireDefault(__webpack_require__(90451));
var _react = _interopRequireWildcard(__webpack_require__(34885));
var _ImageZoomableUi = _interopRequireDefault(__webpack_require__(95566));
var _Box = _interopRequireDefault(__webpack_require__(40300));
var _core = __webpack_require__(79329);
var _useSelectState2 = _interopRequireDefault(__webpack_require__(88829));
var _ButtonArrow = __webpack_require__(50444);
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) { "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); } return f; })(e, t); }
var __jsx = _react["default"].createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function useImageSlider(props) {
  var images = props.images,
    active = props.active,
    defaultActive = props.defaultActive,
    _onChange = props.onChange;
  var _useSelectState = (0, _useSelectState2["default"])({
      options: Array.from(Array(images.length).keys()),
      value: active,
      defaultValue: defaultActive,
      onChange: function onChange(newVal) {
        if (_onChange) {
          _onChange(newVal);
        }
      },
      allowEmpty: false
    }),
    value = _useSelectState.value,
    setValue = _useSelectState.setValue;
  return {
    active: value,
    setActive: setValue,
    activeImage: images[value],
    images: images
  };
}
var defaultProps = {
  sx: {}
};
var ImageSlider = function ImageSlider(props) {
  var isMobile = props.isMobile,
    arrowsForMobile = props.arrowsForMobile,
    photogridMobile = props.photogridMobile,
    _props$sx = props.sx,
    sx = _props$sx === void 0 ? defaultProps.sx : _props$sx,
    controller = props.controller;
  var _useState = (0, _react.useState)(false),
    arrowsVisible = _useState[0],
    setArrowVisible = _useState[1];
  var zoomState = (0, _react.useRef)({
    zoom: false,
    zoomCursor: false
  });
  var _useState2 = (0, _react.useState)({
      touchStartPosition: null,
      leftTouchDetected: null,
      isDragging: false
    }),
    touchState = _useState2[0],
    setTouchState = _useState2[1];
  (0, _react.useEffect)(function () {
    if (isMobile && arrowsForMobile && arrowsForMobile !== arrowsVisible) {
      setArrowVisible(true);
    }
  }, [isMobile]);
  var mobileImageRef = (0, _react.useRef)();
  var _splitSx = (0, _core.splitSx)(sx),
    _splitSx2 = (0, _slicedToArray2["default"])(_splitSx, 2),
    css = _splitSx2[0],
    customSx = _splitSx2[1];
  var image = (0, _core.getElementSpec)(customSx.$image, {
    __type: _Image["default"],
    $objectFit: "contain",
    width: "100%",
    height: "100%"
  }, {});
  var imageElem = (0, _core.createElement)(image, {
    image: controller.activeImage
  });
  var changeActiveImage = function changeActiveImage() {
    var previous = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    controller.setActive(previous ? controller.active !== 0 ? controller.active - 1 : controller.images.length - 1 : controller.active + 1);
  };
  var handleTouchStart = (0, _react.useCallback)(function (imageTouch) {
    setTouchState(function (prevState) {
      return _objectSpread(_objectSpread({}, prevState), {}, {
        isDragging: true,
        touchStartPosition: imageTouch.touches[0].clientX
      });
    });
  }, []);
  var handleTouchMove = (0, _react.useCallback)(function (imageTouch) {
    var diffX = touchState.touchStartPosition - imageTouch.touches[0].clientX;
    if (diffX < 0) {
      setTouchState(function (prevState) {
        return _objectSpread(_objectSpread({}, prevState), {}, {
          leftTouchDetected: true
        });
      });
      changeActiveImage(true);
    } else {
      setTouchState(function (prevState) {
        return _objectSpread(_objectSpread({}, prevState), {}, {
          leftTouchDetected: false
        });
      });
      changeActiveImage();
    }
  }, [touchState.isDragging, touchState.touchStartPosition]);
  var handleTouchEnd = (0, _react.useCallback)(function () {
    if (touchState.isDragging) {
      setTouchState({
        touchStartPosition: null,
        leftTouchDetected: null,
        isDragging: false
      });
    }
  }, [touchState.isDragging, touchState.touchStartPosition]);
  var arrowButtonClick = function arrowButtonClick() {
    var previous = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    controller.setActive(previous ? controller.active !== 0 ? controller.active - 1 : controller.images.length - 1 : controller.active + 1);
  };
  var changeArrowVisibility = function changeArrowVisibility() {
    var zoom = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var out = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    zoomState.current.zoom = zoom;
    zoomState.current.zoomCursor = false;
    if (arrowsVisible !== (zoom || out ? false : !arrowsVisible) && !isMobile) {
      setArrowVisible(!arrowsVisible);
    }
  };
  var arrowStyles = {
    position: "absolute",
    zIndex: 3,
    top: "50%"
  };
  var arrowIndent = arrowsForMobile ? [photogridMobile ? 15 : -15, 15, null, 15, -15] : [null, null, null, 15, -15];
  (0, _react.useEffect)(function () {
    var _mobileImageRef$curre, _mobileImageRef$curre2;
    mobileImageRef === null || mobileImageRef === void 0 ? void 0 : (_mobileImageRef$curre = mobileImageRef.current) === null || _mobileImageRef$curre === void 0 ? void 0 : _mobileImageRef$curre.addEventListener("touchmove", handleTouchMove);
    mobileImageRef === null || mobileImageRef === void 0 ? void 0 : (_mobileImageRef$curre2 = mobileImageRef.current) === null || _mobileImageRef$curre2 === void 0 ? void 0 : _mobileImageRef$curre2.addEventListener("touchend", handleTouchEnd);
    return function () {
      var _mobileImageRef$curre3, _mobileImageRef$curre4;
      mobileImageRef === null || mobileImageRef === void 0 ? void 0 : (_mobileImageRef$curre3 = mobileImageRef.current) === null || _mobileImageRef$curre3 === void 0 ? void 0 : _mobileImageRef$curre3.removeEventListener("touchmove", handleTouchMove);
      mobileImageRef === null || mobileImageRef === void 0 ? void 0 : (_mobileImageRef$curre4 = mobileImageRef.current) === null || _mobileImageRef$curre4 === void 0 ? void 0 : _mobileImageRef$curre4.removeEventListener("touchend", handleTouchEnd);
    };
  }, [handleTouchMove, handleTouchEnd]);
  var imageWithZoom = arrowsForMobile ? __jsx(_Box["default"], null, imageElem) : __jsx(_ImageZoomableUi["default"], {
    zoom: 2,
    cursorOverride: zoomState.current.zoomCursor
  }, __jsx(_Box["default"], {
    onClick: function onClick() {
      return changeArrowVisibility(!zoomState.current.zoom);
    },
    onMouseOver: function onMouseOver() {
      return changeArrowVisibility();
    },
    onMouseLeave: function onMouseLeave() {
      return changeArrowVisibility(false, true);
    }
  }, imageElem));
  var noZoomImage = __jsx(_Box["default"], null, imageElem);
  var mobileSlider = photogridMobile ? noZoomImage : __jsx(_Box["default"], {
    onTouchStart: handleTouchStart,
    ref: mobileImageRef
  }, imageElem);
  return __jsx(_Box["default"], null, arrowsVisible && controller.images.length > 1 && __jsx(_Box["default"], {
    sx: _objectSpread(_objectSpread({}, arrowStyles), {}, {
      left: arrowIndent
    })
  }, __jsx(_ButtonArrow.ButtonArrowBigLeft, {
    onClick: function onClick() {
      return arrowButtonClick(true);
    },
    onMouseEnter: function onMouseEnter() {
      zoomState.current.zoomCursor = true;
      setArrowVisible(true);
    },
    onMouseLeave: function onMouseLeave() {
      return changeArrowVisibility();
    }
  })), arrowsVisible && controller.images.length > 1 && __jsx(_Box["default"], {
    sx: _objectSpread(_objectSpread({}, arrowStyles), {}, {
      right: arrowIndent
    })
  }, __jsx(_ButtonArrow.ButtonArrowBigRight, {
    onClick: function onClick() {
      return arrowButtonClick();
    },
    onMouseEnter: function onMouseEnter() {
      zoomState.current.zoomCursor = true;
      setArrowVisible(true);
    },
    onMouseLeave: function onMouseLeave() {
      return changeArrowVisibility();
    }
  })), __jsx(_Box["default"], {
    sx: _objectSpread({
      cursor: "pointer"
    }, css)
  }, isMobile ? mobileSlider : photogridMobile ? noZoomImage : imageWithZoom));
};
var _default = ImageSlider;
exports["default"] = _default;

/***/ }),

/***/ 95566:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(__webpack_require__(20389));
var _classCallCheck2 = _interopRequireDefault(__webpack_require__(98986));
var _createClass2 = _interopRequireDefault(__webpack_require__(30428));
var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(11112));
var _inherits2 = _interopRequireDefault(__webpack_require__(10564));
var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(5153));
var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(53531));
var _react = _interopRequireDefault(__webpack_require__(34885));
var _Box = _interopRequireDefault(__webpack_require__(40300));
var __jsx = _react["default"].createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createSuper(t) { var r = _isNativeReflectConstruct(); return function () { var e, o = (0, _getPrototypeOf2["default"])(t); if (r) { var s = (0, _getPrototypeOf2["default"])(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0, _possibleConstructorReturn2["default"])(this, e); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var ImageZoomable = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(ImageZoomable, _React$Component);
  var _super = _createSuper(ImageZoomable);
  function ImageZoomable(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, ImageZoomable);
    _this = _super.call(this, props);
    _this.containerRef = /*#__PURE__*/_react["default"].createRef();
    _this.itemRef = /*#__PURE__*/_react["default"].createRef();
    _this.itemCopyRef = /*#__PURE__*/_react["default"].createRef();
    _this._onClick = _this._onClick.bind((0, _assertThisInitialized2["default"])(_this));
    _this._onMouseMove = _this._onMouseMove.bind((0, _assertThisInitialized2["default"])(_this));
    _this._onMouseLeave = _this._onMouseLeave.bind((0, _assertThisInitialized2["default"])(_this));
    _this._onMouseEnter = _this._onMouseEnter.bind((0, _assertThisInitialized2["default"])(_this));
    _this.state = {
      isZooming: false
    };
    return _this;
  }
  (0, _createClass2["default"])(ImageZoomable, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this._containerSize = {
        width: this.containerRef.current.clientWidth,
        height: this.containerRef.current.clientHeight
      };
      this._itemSize = {
        width: this._containerSize.width,
        height: this._containerSize.height
      };
      // if (this.props.objectFit === "cover") {
      //     this._itemSize = {
      //         width: this._containerSize.width,
      //         height: this._containerSize.height
      //     };
      // } else if (this.props.mode === "contain") {
      //     // calculate container for contain.
      // }

      var zoom = this.props.zoom;
      this._maxMovementRange = {
        x: this._itemSize.width * (zoom - 1),
        y: this._itemSize.height * (zoom - 1)
      };

      // Touch
      // this.zoomer = new AbstractZoomer();
      //
      // this.zoomer.addEventListener("move", coords => {
      //     this.itemRef.current.style.transform = `translateX(${
      //         coords.x
      //         }px) translateY(${coords.y}px) scale(${coords.scale})`;
      // });
      //
      // this.zoomer.containerSize = {
      //     width: this.containerRef.current.clientWidth,
      //     height: this.containerRef.current.clientHeight
      // };
      //
      // if (this.props.mode === "natural" || this.props.mode === "cover") {
      //     this.zoomer.itemSize = {
      //         width: this.zoomer.containerSize.width,
      //         height: this.zoomer.containerSize.height
      //     };
      // }
    }
  }, {
    key: "_getMouseCoordinates",
    value: function _getMouseCoordinates(e) {
      this._mouseRelativeCoords = {
        x: e.nativeEvent.offsetX / this._itemSize.width,
        y: e.nativeEvent.offsetY / this._itemSize.height
      };
    }
  }, {
    key: "_calculateTransforms",
    value: function _calculateTransforms() {
      var zoom = this.props.zoom;
      return {
        transformX: -(this._mouseRelativeCoords.x - 0.5) * this._maxMovementRange.x / zoom,
        transformY: -(this._mouseRelativeCoords.y - 0.5) * this._maxMovementRange.y / zoom,
        scale: zoom
      };
    }
  }, {
    key: "_disableClickZoom",
    value: function _disableClickZoom() {
      var _this2 = this;
      this.setState({
        isDisappearing: true
      });
      this.disappearTimeout = setTimeout(function () {
        _this2.setState({
          isZooming: false,
          isDisappearing: false
        });
      }, 200);
    }
  }, {
    key: "_onClick",
    value: function _onClick(e) {
      if (!this.state.isZooming) {
        if (this._mouseRelativeCoords === undefined) {
          this._getMouseCoordinates(e);
        }
        clearTimeout(this.disappearTimeout);
        this.setState(_objectSpread({
          isZooming: true,
          isDisappearing: false
        }, this._calculateTransforms()));
      } else {
        this._disableClickZoom();
      }
    }
  }, {
    key: "_onMouseMove",
    value: function _onMouseMove(e) {
      if (!this.props.cursorOverride) {
        this._getMouseCoordinates(e);
        if (this.state.isZooming) {
          this.setState(_objectSpread({}, this._calculateTransforms()));
        }
      }
    }
  }, {
    key: "_onMouseEnter",
    value: function _onMouseEnter() {
      clearTimeout(this.leaveTimeout);
    }
  }, {
    key: "_onMouseLeave",
    value: function _onMouseLeave() {
      var _this3 = this;
      this.leaveTimeout = setTimeout(function () {
        _this3._disableClickZoom();
      }, 200);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        zoom = _this$props.zoom,
        children = _this$props.children,
        cursorOverride = _this$props.cursorOverride;
      var transform = "scale(".concat(this.state.scale, ") translate(").concat(this.state.transformX, "px, ").concat(this.state.transformY, "px)");
      return __jsx(_Box["default"], {
        sx: {
          position: "relative",
          overflow: "hidden",
          cursor: cursorOverride ? "pointer" : this.state.isZooming ? "zoom-out" : "zoom-in"
        },
        ref: this.containerRef,
        onClick: this._onClick,
        onMouseMove: this._onMouseMove,
        onMouseLeave: this._onMouseLeave,
        onMouseEnter: this._onMouseEnter
      }, __jsx(_Box["default"], {
        ref: this.itemRef,
        sx: {
          transformOrigin: "50% 50%",
          transition: "none",
          height: "100%",
          width: "100%",
          minWidth: "inherit",
          minHeight: "inherit",
          maxWidth: "inherit",
          maxHeight: "inherit"
        },
        fitW: true,
        fitH: true
      }, children), this.state.isZooming && __jsx(_Box["default"], {
        ref: this.itemCopyRef,
        style: {
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          minWidth: "inherit",
          minHeight: "inherit",
          maxWidth: "inherit",
          maxHeight: "inherit",
          transformOrigin: "50% 50%",
          transition: "opacity .2s",
          opacity: this.state.isDisappearing ? 0 : 1,
          transform: transform,
          pointerEvents: "none"
        },
        fitW: true,
        fitH: true
      }, children));
    }
  }]);
  return ImageZoomable;
}(_react["default"].Component);
ImageZoomable.defaultProps = {
  zoom: 2
};
var _default = ImageZoomable;
exports["default"] = _default;

/***/ }),

/***/ 94444:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(__webpack_require__(20389));
var _LinkRaw = _interopRequireDefault(__webpack_require__(88244));
var _Box = _interopRequireDefault(__webpack_require__(40300));
var _react = _interopRequireWildcard(__webpack_require__(34885));
var _RouteContext = __webpack_require__(73157);
var _handleLanguageCharacters = __webpack_require__(59926);
var _replaceSpecialCharacters = _interopRequireDefault(__webpack_require__(64426));
var _useAppConfiguration2 = _interopRequireDefault(__webpack_require__(15366));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) { "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); } return f; })(e, t); }
var __jsx = _react["default"].createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var QuestionIcon = function QuestionIcon(props) {
  return __jsx("svg", props, __jsx("path", {
    fill: "none",
    d: "M58.49 50.009c-4.677 0-8.481 3.804-8.481 8.481 0 4.676 3.805 8.48 8.481 8.48 4.678 0 8.481-3.805 8.481-8.48 0-4.677-3.803-8.481-8.481-8.481z"
  }), __jsx("path", {
    fill: "#2F4658",
    d: "M58.49 48.554c-5.479 0-9.936 4.458-9.936 9.936 0 5.479 4.457 9.936 9.936 9.936s9.936-4.456 9.936-9.936c0-5.479-4.457-9.936-9.936-9.936zm0 18.416c-4.677 0-8.481-3.805-8.481-8.48 0-4.677 3.805-8.481 8.481-8.481 4.678 0 8.481 3.804 8.481 8.481 0 4.675-3.803 8.48-8.481 8.48z"
  }), __jsx("path", {
    fill: "#2F4658",
    d: "M57.188 60.381c0-.278.038-.526.114-.744.076-.218.197-.425.365-.618a4.31 4.31 0 0 1 .693-.591 6.83 6.83 0 0 0 .605-.491c.159-.144.272-.286.341-.43.076-.143.114-.302.114-.478 0-.269-.102-.471-.304-.604-.193-.144-.466-.214-.82-.214a3.41 3.41 0 0 0-1.045.164 6.933 6.933 0 0 0-1.059.44l-.668-1.348a6.834 6.834 0 0 1 1.336-.555 5.483 5.483 0 0 1 1.575-.215c.874 0 1.549.21 2.029.63.487.42.73.954.73 1.601 0 .344-.056.642-.165.895a2.271 2.271 0 0 1-.491.706c-.218.21-.491.436-.818.68a6.282 6.282 0 0 0-.567.453 1.1 1.1 0 0 0-.276.366 1.318 1.318 0 0 0-.063.44v.365h-1.625l-.001-.452zm-.201 2.558c0-.386.104-.654.315-.807.21-.158.467-.239.769-.239.294 0 .546.081.756.239.211.152.314.421.314.807 0 .369-.104.638-.314.806a1.21 1.21 0 0 1-.756.239c-.302 0-.559-.079-.769-.239-.21-.169-.315-.437-.315-.806z"
  }));
};
QuestionIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "48.49 48.49 20 20"
};
var CollectionButton = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var _producer$name, _producer, _producer2, _producer3, _global$__appConfig__, _global$__appConfig__2, _global$__appConfig__3;
  var product = _ref.product,
    setShowProducent = _ref.setShowProducent,
    _ref$isCollection = _ref.isCollection,
    isCollection = _ref$isCollection === void 0 ? true : _ref$isCollection,
    _ref$rootCategory = _ref.rootCategory,
    rootCategory = _ref$rootCategory === void 0 ? "/" : _ref$rootCategory,
    _ref$brandCategory = _ref.brandCategory,
    brandCategory = _ref$brandCategory === void 0 ? "/" : _ref$brandCategory;
  var _useRouteContext = (0, _RouteContext.useRouteContext)(),
    Link = _useRouteContext.Link;
  var _useAppConfiguration = (0, _useAppConfiguration2["default"])(),
    language = _useAppConfiguration.language;
  var buttonStyles = {
    display: "flex",
    height: "100%",
    bg: "beige",
    px: "s6",
    // py: 10,
    ml: "s4",
    borderRadius: 5,
    cursor: "pointer",
    alignItems: "center",
    justifyContent: "space-between"
  };
  var producer = product.producer,
    collection = product.collection;
  producer = typeof producer === "string" ? producer : (_producer$name = (_producer = producer) === null || _producer === void 0 ? void 0 : _producer.name) !== null && _producer$name !== void 0 ? _producer$name : "";
  var collectionName = (collection === null || collection === void 0 ? void 0 : collection.name) && (0, _handleLanguageCharacters.removeSpecificCharactersFromString)({
    string: collection.name.toLowerCase().replace(/\s/g, "_").replace(/\//g, "_").replace(/&/g, "_").replace(/(_)\1+/g, "_")
  });
  var collectionUrls = {
    collection: producer ? "".concat(rootCategory, "/").concat((0, _handleLanguageCharacters.removeSpecificCharactersFromString)({
      string: (_producer2 = producer) === null || _producer2 === void 0 ? void 0 : _producer2.toLowerCase(),
      removeSpaces: true
    }), "-").concat(collectionName) : "".concat(rootCategory, "/").concat((0, _handleLanguageCharacters.removeSpecificCharactersFromString)({
      string: collection === null || collection === void 0 ? void 0 : collection.name,
      removeSpaces: true
    }).toLowerCase()),
    producer: "".concat(rootCategory).concat(brandCategory, "/").concat((0, _handleLanguageCharacters.removeSpecificCharactersFromString)({
      string: (_producer3 = producer) === null || _producer3 === void 0 ? void 0 : _producer3.toLowerCase(),
      removeSpaces: true,
      spaceChar: "-"
    }))
  };
  var label = isCollection ? collection === null || collection === void 0 ? void 0 : collection.name : producer;
  var producerData = !isCollection && ((_global$__appConfig__ = (_global$__appConfig__2 = __webpack_require__.g.__appConfig__.producers[language]) === null || _global$__appConfig__2 === void 0 ? void 0 : _global$__appConfig__2[producer.toLowerCase()]) !== null && _global$__appConfig__ !== void 0 ? _global$__appConfig__ : (_global$__appConfig__3 = __webpack_require__.g.__appConfig__.producers[language]) === null || _global$__appConfig__3 === void 0 ? void 0 : _global$__appConfig__3["dajar"]);
  return __jsx(_Box["default"], {
    sx: buttonStyles,
    ref: ref
  }, __jsx(Link, {
    href: isCollection ? (0, _replaceSpecialCharacters["default"])(collectionUrls.collection) : (0, _replaceSpecialCharacters["default"])(collectionUrls.producer)
  }, __jsx(_LinkRaw["default"], {
    title: label
  }, label)), producerData && __jsx(_Box["default"], {
    as: "span",
    sx: {
      height: 22,
      marginLeft: 5
    },
    onClick: function onClick() {
      return setShowProducent(_objectSpread(_objectSpread({}, producerData), {}, {
        producer: producer
      }));
    }
  }, __jsx(QuestionIcon, null)));
});
var _default = CollectionButton;
exports["default"] = _default;

/***/ }),

/***/ 59678:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _react = _interopRequireDefault(__webpack_require__(34885));
var _Box = _interopRequireDefault(__webpack_require__(40300));
var _Container = _interopRequireDefault(__webpack_require__(58709));
var _Grid = _interopRequireDefault(__webpack_require__(98290));
var _langLibrary = _interopRequireDefault(__webpack_require__(51493));
var _parseProductDescription = _interopRequireDefault(__webpack_require__(85799));
var __jsx = _react["default"].createElement;
var ProductDescription2Columns = function ProductDescription2Columns(props) {
  var productInfo = props.productInfo;
  var translations = {
    technicalData: (0, _langLibrary["default"])("Technical data"),
    shortDescription: (0, _langLibrary["default"])("Details"),
    length: (0, _langLibrary["default"])("Length [cm]"),
    width: (0, _langLibrary["default"])("Width [cm]"),
    shape: (0, _langLibrary["default"])("Shape"),
    producer: (0, _langLibrary["default"])("Producer"),
    height: (0, _langLibrary["default"])("Height [cm]"),
    depth: (0, _langLibrary["default"])("Depth [cm]"),
    capacity: (0, _langLibrary["default"])("Capacity [l]"),
    number_of_people: (0, _langLibrary["default"])("Number of people"),
    dajar_collection: (0, _langLibrary["default"])("Dajar collection"),
    material: (0, _langLibrary["default"])("Material"),
    application: (0, _langLibrary["default"])("Application"),
    diameter: (0, _langLibrary["default"])("Diameter [cm]"),
    color_list: (0, _langLibrary["default"])("Color list"),
    pattern_list: (0, _langLibrary["default"])("Pattern list"),
    feature: (0, _langLibrary["default"])("Feature"),
    composition: (0, _langLibrary["default"])("Composition"),
    max_load: (0, _langLibrary["default"])("Max load"),
    ean: (0, _langLibrary["default"])("Ean"),
    weight: (0, _langLibrary["default"])("Weight [kg]"),
    safetyDescription: (0, _langLibrary["default"])("safety_description")
  };
  return __jsx(_Container["default"], null, __jsx(_Grid["default"], {
    cols: [1, null, null, 2],
    gap: "s10",
    sx: {
      mt: "s12",
      height: "fit-content"
    }
  }, __jsx(_Box["default"], {
    sx: {
      color: "main",
      font: "body",
      a: {
        color: "main"
      },
      ml: [0, null, null, "s11"],
      lineHeight: 1.3,
      "h2, h3, h4, h5": {
        margin: 0
      },
      ul: {
        paddingLeft: 40
      },
      "ul br": {
        display: "none"
      },
      "ul li": {
        my: 3,
        paddingLeft: 3
      }
    },
    dangerouslySetInnerHTML: {
      __html: productInfo !== null && productInfo !== void 0 && productInfo.description ? (0, _parseProductDescription["default"])(productInfo.description) : ""
    }
  }), __jsx(_Box["default"], null, __jsx(_Box["default"], {
    sx: {
      color: "main",
      font: "s",
      px: ["s8", null, null, "s11"],
      py: ["s9", null, null, "s11"],
      mr: [0, null, null, "s11"],
      bg: "beige"
    }
  }, productInfo.technicalData && __jsx(_Box["default"], {
    sx: {
      mb: productInfo.shortDescription ? "s11" : 0
    }
  }, __jsx(_Box["default"], {
    sx: {
      font: "label",
      mb: "s8"
    }
  }, translations["technicalData"]), __jsx(_Box["default"], {
    sx: {
      font: "s_sans",
      width: "100%"
    }
  }, productInfo.technicalData.map(function (data) {
    if (data !== null && data !== void 0 && data.name) {
      return __jsx(_Box["default"], {
        sx: {
          display: "flex",
          mb: "s5",
          justifyContent: "space-between"
        }
      }, __jsx(_Box["default"], {
        sx: {
          flexBasis: ["50%", null, null, "55%"]
        }
      }, translations[data.label]), __jsx(_Box["default"], {
        sx: {
          flexBasis: ["45%", null, null, "40%"]
        }
      }, data.label === "capacity" ? parseFloat(data.name) / 1000 : isNaN(data.name) ? data.name.toString().split(",").join(", ") : parseFloat(data.name).toString()));
    }
  }))), productInfo.shortDescription && __jsx(_Box["default"], null, __jsx(_Box["default"], {
    sx: {
      font: "label",
      mb: "s8"
    }
  }, translations["shortDescription"]), __jsx(_Box["default"], {
    sx: {
      font: "s_sans",
      width: "100%",
      lineHeight: 1.6
    },
    dangerouslySetInnerHTML: {
      __html: (0, _parseProductDescription["default"])(productInfo.shortDescription)
    }
  })), __jsx(_Box["default"], {
    as: "p",
    sx: {
      font: "s_sans",
      mt: "s10",
      lineHeight: 1.6
    }
  }, translations.safetyDescription)))));
};
var _default = ProductDescription2Columns;
exports["default"] = _default;

/***/ }),

/***/ 53326:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(__webpack_require__(20389));
var _slicedToArray2 = _interopRequireDefault(__webpack_require__(6780));
var _react = _interopRequireDefault(__webpack_require__(34885));
var _Box = _interopRequireDefault(__webpack_require__(40300));
var _Accordion = _interopRequireDefault(__webpack_require__(73650));
var _ShowHide = _interopRequireDefault(__webpack_require__(2500));
var _Button = _interopRequireDefault(__webpack_require__(96088));
var _parseProductDescription = _interopRequireDefault(__webpack_require__(85799));
var __jsx = _react["default"].createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var ChevronDownIcon = function ChevronDownIcon(props) {
  return __jsx("svg", props, __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.923 10.263l.848-.849 5.576 5.576 5.576-5.576.848.849-6.424 6.424-6.424-6.424z"
  }));
};
ChevronDownIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
};
var defaultProps = {
  qtyWithButton: false,
  accordionTextFont: "body",
  accordionLabelFont: "label",
  detailMarginTop: "s8",
  accordionBarPadding: {
    top: 17,
    bottom: 13
  }
};
var ProductDataAccordion = function ProductDataAccordion(props) {
  var productInfo = props.productInfo,
    translations = props.translations,
    br = props.br,
    _props$detailMarginTo = props.detailMarginTop,
    detailMarginTop = _props$detailMarginTo === void 0 ? defaultProps.detailMarginTop : _props$detailMarginTo,
    _props$accordionLabel = props.accordionLabelFont,
    accordionLabelFont = _props$accordionLabel === void 0 ? defaultProps.accordionLabelFont : _props$accordionLabel,
    _props$accordionTextF = props.accordionTextFont,
    accordionTextFont = _props$accordionTextF === void 0 ? defaultProps.accordionTextFont : _props$accordionTextF,
    _props$qtyWithButton = props.qtyWithButton,
    qtyWithButton = _props$qtyWithButton === void 0 ? defaultProps.qtyWithButton : _props$qtyWithButton,
    _props$accordionBarPa = props.accordionBarPadding,
    accordionBarPadding = _props$accordionBarPa === void 0 ? defaultProps.accordionBarPadding : _props$accordionBarPa;
  productInfo.safetyTitle = translations.safetyDescription;
  return __jsx(_Accordion["default"], {
    sx: {
      mt: "s10"
    }
  }, __jsx(_Box["default"], {
    sx: {
      height: qtyWithButton ? 0 : "1px",
      bg: "neutral"
    }
  }), productInfo && Object.entries(productInfo).map(function (_ref, index) {
    var _ref2 = (0, _slicedToArray2["default"])(_ref, 2),
      title = _ref2[0],
      value = _ref2[1];
    return value === null || value === "" ? null : [__jsx(_Accordion["default"].Section, {
      isOpenAtInit: index === 0
    }, __jsx(_Button["default"], {
      sx: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        pt: accordionBarPadding.top,
        pb: accordionBarPadding.bottom,
        width: "100%",
        color: "main"
      }
    }, function (_ref3) {
      var selected = _ref3.selected;
      return __jsx(_react["default"].Fragment, null, __jsx(_Box["default"], {
        sx: {
          font: accordionLabelFont
        }
      }, translations[title]), __jsx(_Box["default"], {
        sx: {
          transform: selected ? "rotate(180deg)" : "none",
          transition: "all .3s ease-out"
        }
      }, __jsx(ChevronDownIcon, null)));
    }), __jsx(_ShowHide["default"], null, __jsx(_Box["default"], {
      sx: _objectSpread({
        p: "16px 0px",
        pt: 0,
        font: accordionTextFont,
        color: "main"
      }, br)
    }, Array.isArray(value) > 0 ? value.map(function (value, index) {
      if (!(value !== null && value !== void 0 && value.name)) {
        return;
      }
      return __jsx(_Box["default"], {
        sx: {
          display: "flex",
          flexDirection: "row",
          width: "100%",
          marginTop: detailMarginTop
        },
        key: index
      }, __jsx(_Box["default"], {
        sx: {
          width: "50%"
        }
      }, translations[value.label]), __jsx(_Box["default"], {
        sx: {
          width: "50%"
        }
      }, value.label === "capacity" ? parseFloat(value.name) / 1000 : isNaN(value.name) ? value.name.toString().split(",").join(", ") : parseFloat(value.name).toString()));
    }) : __jsx(_Box["default"], {
      sx: {
        a: {
          color: "main"
        }
      },
      dangerouslySetInnerHTML: {
        __html: (0, _parseProductDescription["default"])(value)
      }
    })))), __jsx(_Box["default"], {
      sx: {
        height: qtyWithButton ? 0 : "1px",
        bg: "neutral"
      }
    })];
  }));
};
var _default = ProductDataAccordion;
exports["default"] = _default;

/***/ }),

/***/ 5291:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(7125);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _defineProperty2 = _interopRequireDefault(__webpack_require__(20389));
var _react = _interopRequireWildcard(__webpack_require__(34885));
var _langLibrary = _interopRequireDefault(__webpack_require__(51493));
var _Product = _interopRequireDefault(__webpack_require__(71438));
var _Box = _interopRequireDefault(__webpack_require__(40300));
var _Container = _interopRequireDefault(__webpack_require__(58709));
var _Grid = _interopRequireDefault(__webpack_require__(98290));
var _LinkRaw = _interopRequireDefault(__webpack_require__(88244));
var _Selectable = _interopRequireDefault(__webpack_require__(53910));
var _QuantityPicker = __webpack_require__(34345);
var _ImageSliderUi = _interopRequireWildcard(__webpack_require__(97530));
var _Image = _interopRequireWildcard(__webpack_require__(90451));
var _ImageZoomableUi = _interopRequireDefault(__webpack_require__(95566));
var _ProductDescriptionAccordion = _interopRequireDefault(__webpack_require__(53326));
var _ProductDescription2Columns = _interopRequireDefault(__webpack_require__(59678));
var _CollectionButton = _interopRequireDefault(__webpack_require__(94444));
var _RouteContext = __webpack_require__(73157);
var _useCartModifier2 = _interopRequireDefault(__webpack_require__(82106));
var _useOptionPicker2 = _interopRequireDefault(__webpack_require__(55546));
var _usePriceWithCurrency = _interopRequireDefault(__webpack_require__(81890));
var _usePriceFormatter = _interopRequireDefault(__webpack_require__(49412));
var _useRecentlyViewedProducts = __webpack_require__(79105);
var _useProductHeadOptions = __webpack_require__(71855);
var _useSelectScrollableStack = _interopRequireWildcard(__webpack_require__(57689));
var _LanguageProvider = __webpack_require__(8989);
var _countCatalogPrice = _interopRequireDefault(__webpack_require__(36909));
var _isDiscount = _interopRequireDefault(__webpack_require__(46484));
var _percentDecrease = _interopRequireDefault(__webpack_require__(28532));
var _getLowProductAvailability = _interopRequireDefault(__webpack_require__(63712));
var _getAvailabilityDate = _interopRequireDefault(__webpack_require__(16388));
var _showLowestPrice = _interopRequireDefault(__webpack_require__(31499));
var _hasStoreAdditionalFunctionalities = _interopRequireDefault(__webpack_require__(36229));
var _isGlobalEnvEnabled = _interopRequireDefault(__webpack_require__(60111));
var _TokenProvider = __webpack_require__(36286);
var _WishlistProvider = __webpack_require__(54730);
var _Tooltip = _interopRequireDefault(__webpack_require__(747));
var _HitProductPage = _interopRequireDefault(__webpack_require__(53171));
var _ButtonRaw = _interopRequireDefault(__webpack_require__(30650));
var _HitProvider = __webpack_require__(17090);
var _getPromoCategory = _interopRequireDefault(__webpack_require__(5446));
var _DialogUi = _interopRequireDefault(__webpack_require__(19281));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) { "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); } return f; })(e, t); }
var __jsx = _react["default"].createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var ChevronLeftIcon = function ChevronLeftIcon(props) {
  return __jsx("svg", props, __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.883 13.438l6.542 6.99-.876.82-7.87-8.41 7.87-8.41.876.82-6.542 6.99H20.5v1.2H4.883z",
    fill: "#2E4557"
  }));
};
ChevronLeftIcon.defaultProps = {
  width: "24",
  height: "25",
  viewBox: "0 0 24 25",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
};
var CloseIcon = function CloseIcon(props) {
  return __jsx("svg", props, __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.347 20.838l-15-15 .848-.848 15 15-.848.848z"
  }), __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.347 19.838l15-15 .848.849-15 15-.848-.849z"
  }));
};
CloseIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
};
var ProductHead = function ProductHead(props) {
  var _sale$left, _sale$maxQtyPerClient, _product$category, _sale$maxQtyPerClient2, _product$price$specia, _additionalStyles$qty, _additionalStyles$qty2, _additionalStyles$sku, _sale$price;
  var productCategory = props.productCategory,
    photoGrid = props.photoGrid,
    button = props.button,
    qtyWithButton = props.qtyWithButton,
    additionalStyles = props.additionalStyles,
    isMobile = props.isMobile,
    imageOverlayOpacity = props.imageOverlayOpacity,
    roundness = props.roundness,
    buttonArrowLeft = props.buttonArrowLeft,
    buttonArrowRight = props.buttonArrowRight,
    optionsSelector = props.optionsSelector,
    productFromOutlet = props.productFromOutlet,
    _props$showProducerAn = props.showProducerAndCollectionInfo,
    showProducerAndCollectionInfo = _props$showProducerAn === void 0 ? false : _props$showProducerAn,
    _props$showDescriptio = props.showDescriptionAsAccordion,
    showDescriptionAsAccordion = _props$showDescriptio === void 0 ? true : _props$showDescriptio,
    _props$showAdditional = props.showAdditionalFeeInfo,
    showAdditionalFeeInfo = _props$showAdditional === void 0 ? false : _props$showAdditional,
    brandCategories = props.brandCategories,
    rootCategories = props.rootCategories,
    wishlistIcon = props.wishlistIcon,
    wishlistOutlineIcon = props.wishlistOutlineIcon,
    isProductPageHit = props.isProductPageHit;
  var priceFormatter = (0, _usePriceFormatter["default"])();
  var _useToken = (0, _TokenProvider.useToken)(),
    token = _useToken.token;
  var _useRouteContext = (0, _RouteContext.useRouteContext)(),
    Link = _useRouteContext.Link;
  var _useHit = (0, _HitProvider.useHit)(!isProductPageHit),
    sale = _useHit.sale,
    hitIsActive = _useHit.isActive;
  var translations = {
    description: (0, _langLibrary["default"])("Product description"),
    technicalData: (0, _langLibrary["default"])("Technical data"),
    shortDescription: (0, _langLibrary["default"])("Details"),
    outOfStock: (0, _langLibrary["default"])("Out of stock"),
    lastItemsInStock: (0, _langLibrary["default"])("Last items in stock"),
    catalogPrice: (0, _langLibrary["default"])("Catalog price"),
    quantity: (0, _langLibrary["default"])("Quantity"),
    addToCart: (0, _langLibrary["default"])("add to cart"),
    bonusPoints: (0, _langLibrary["default"])("bonus ePoints"),
    sale: (0, _langLibrary["default"])("Sale"),
    "new": (0, _langLibrary["default"])("New arrival"),
    brexit: (0, _langLibrary["default"])("Brexit"),
    productAsteriskInfo: (0, _langLibrary["default"])("product available in different variant"),
    final_price: (0, _langLibrary["default"])("price"),
    price: (0, _langLibrary["default"])("price"),
    producer: (0, _langLibrary["default"])("Producer"),
    brand: (0, _langLibrary["default"])("Brand"),
    height: (0, _langLibrary["default"])("Height [cm]"),
    dajar_collection: (0, _langLibrary["default"])("Dajar collection"),
    deliveryTime: (0, _langLibrary["default"])("Delivery time"),
    shippingTime: (0, _langLibrary["default"])("Shipping time info"),
    carryPackage: (0, _langLibrary["default"])("Carry package"),
    freeShipping: (0, _langLibrary["default"])("Free delivery"),
    shippingPrice: (0, _langLibrary["default"])("Shipping cost with standard delivery price"),
    availabilityInfo: (0, _langLibrary["default"])("The product will be available"),
    priceIncludesTax: (0, _langLibrary["default"])("Price includes tax"),
    freeDeliveryInfo: (0, _langLibrary["default"])("Free delivery PDP info {{freeDeliveryFrom}}", {
      freeDeliveryFrom: "300 ".concat(priceFormatter.currencySymbol)
    }),
    weight: (0, _langLibrary["default"])("Weight [kg]"),
    lowestPrice: (0, _langLibrary["default"])("Lowest price info"),
    offerValid: (0, _langLibrary["default"])("Offer valid while stocks last"),
    addToWishlist: (0, _langLibrary["default"])("Add product to wishlist"),
    removeFromWishList: (0, _langLibrary["default"])("Remove from wishlist"),
    productInWishlist: (0, _langLibrary["default"])("Product on wishlist"),
    productCode: (0, _langLibrary["default"])("product code"),
    wishlistTooltip: (0, _langLibrary["default"])("Wishlist inactive tooltip"),
    hitOfWeek: (0, _langLibrary["default"])("Hit of the week"),
    hitOfMonth: (0, _langLibrary["default"])("Hit of the month"),
    outlet: (0, _langLibrary["default"])("Outlet"),
    phone: (0, _langLibrary["default"])("Phone"),
    hitDay: (0, _langLibrary["default"])("Hit of the day"),
    onlyLeftInStock: (0, _langLibrary["default"])("Only {{qty}} left in stock", {
      qty: hitIsActive ? (_sale$left = sale === null || sale === void 0 ? void 0 : sale.left) !== null && _sale$left !== void 0 ? _sale$left : 0 : 0
    }),
    maxAvailableQtyHit: (0, _langLibrary["default"])("Available qty for person in hit {{qty}}", {
      qty: (_sale$maxQtyPerClient = sale === null || sale === void 0 ? void 0 : sale.maxQtyPerClient) !== null && _sale$maxQtyPerClient !== void 0 ? _sale$maxQtyPerClient : 1
    }),
    additionalPromoLabel: (0, _langLibrary["default"])("additional_promo_label"),
    safetyTitle: (0, _langLibrary["default"])("safety_title"),
    safetyDescription: (0, _langLibrary["default"])("safety_description")
  };
  var promoLabels = [translations.hitOfWeek, translations.hitOfMonth, translations["new"], translations.outlet];
  var _useOptionPicker = (0, _useOptionPicker2["default"])(props.product),
    product = _useOptionPicker.product,
    options = _useOptionPicker.options,
    selectedValues = _useOptionPicker.selectedValues;
  var currentProductIsHit = isProductPageHit ? props.product.sku === product.sku : false;
  var priceWithCurrency = (0, _usePriceWithCurrency["default"])();
  var _useLanguage = (0, _LanguageProvider.useLanguage)(),
    language = _useLanguage.language;
  var _useWishlist = (0, _WishlistProvider.useWishlist)(),
    addToWishlist = _useWishlist.addToWishlist,
    removeFromWishlist = _useWishlist.removeFromWishlist,
    accountWishlist = _useWishlist.accountWishlist;
  var isFirstRun = (0, _react.useRef)({
    first: true,
    product: product
  });
  var counter = (0, _react.useRef)(0);
  var isInWishlist = accountWishlist === null || accountWishlist === void 0 ? void 0 : accountWishlist.includes(product.sku);
  var currentProductGotAdditionalLabel = (0, _getPromoCategory["default"])({
    language: language.language,
    ids: product === null || product === void 0 ? void 0 : (_product$category = product.category) === null || _product$category === void 0 ? void 0 : _product$category.ids
  });
  (0, _react.useEffect)(function () {
    if (isFirstRun.current.first && product) {
      isFirstRun.current = {
        first: false,
        product: product
      };
      return;
    }
    counter.current += 1;
    history.pushState("", product.name, product.url);
  }, [product.url]);
  if (typeof window !== "undefined") {
    window.onpopstate = function (event) {
      if (counter.current > 0) {
        history.go(counter.current * -1);
        counter.current = 0;
      }
    };
  }
  var quantityPicker = (0, _QuantityPicker.useQuantityPicker)({
    selectOptionsAmount: 9,
    maxValue: isProductPageHit ? (_sale$maxQtyPerClient2 = sale === null || sale === void 0 ? void 0 : sale.maxQtyPerClient) !== null && _sale$maxQtyPerClient2 !== void 0 ? _sale$maxQtyPerClient2 : 0 : __webpack_require__.g.__appConfig__.quantityPickerMaxValue
  });
  var _useCartModifier = (0, _useCartModifier2["default"])({
      product: product,
      isProductPageHit: currentProductIsHit,
      categoryName: productCategory === null ? undefined : productCategory.name,
      onSuccess: function onSuccess() {
        quantityPicker.reset();
      }
    }),
    loading = _useCartModifier.loading,
    add = _useCartModifier.add;
  var outOfStock = (0, _getLowProductAvailability["default"])(product.availability.level);
  var lowAvailabilityLevel = (0, _isGlobalEnvEnabled["default"])({
    globalEnv: __webpack_require__.g.__appConfig__.pdpLastItemsStockVisibility,
    language: language
  }) && (0, _getLowProductAvailability["default"])(product.availability.level, false);
  var _useState = (0, _react.useState)(0),
    selectedImageIndex = _useState[0],
    setSelectedImageIndex = _useState[1];
  (0, _useRecentlyViewedProducts.useRecentlyViewedProducts)(product);
  var _useProductHeadOption = (0, _useProductHeadOptions.useProductHeadOptions)(),
    updateActiveProduct = _useProductHeadOption.updateActiveProduct;
  (0, _react.useEffect)(function () {
    updateActiveProduct(product);
    setSelectedImageIndex(0);
  }, [product]);
  var productImages = product.images.map(function (image) {
    return _objectSpread(_objectSpread({}, image), {}, {
      id: image.originalSrc
    });
  });
  var productThumbnails = product.images.map(function (image) {
    return _objectSpread(_objectSpread({}, image), {}, {
      id: image.originalSrc
    });
  });
  var imageSlider = (0, _ImageSliderUi.useImageSlider)({
    images: productImages,
    onChange: function onChange(index) {
      setSelectedImageIndex(index);
    },
    active: selectedImageIndex
  });
  var thumbnails = photoGrid ? null : (0, _useSelectScrollableStack.useSelectScrollableStack)({
    options: productThumbnails,
    value: productImages[selectedImageIndex] || null,
    allowEmpty: false,
    onChange: function onChange(_, index) {
      setSelectedImageIndex(index);
    }
  });
  var shippingLimitPrice = __webpack_require__.g.__appConfig__.shippingLimitPrices[language.language];
  var productPrice = (_product$price$specia = product.price.special) !== null && _product$price$specia !== void 0 ? _product$price$specia : product.price.regular;
  var shippingLimitMinusPrice = shippingLimitPrice - productPrice;
  var availabilityDate = (outOfStock || !product.isVisible) && (0, _getAvailabilityDate["default"])(product, translations.availabilityInfo);
  var disableProductForHit = isProductPageHit && (!(sale !== null && sale !== void 0 && sale.left) || (sale === null || sale === void 0 ? void 0 : sale.left) === 0 || !hitIsActive);
  var addToCartButton = /*#__PURE__*/_react["default"].cloneElement(button, {
    sx: {
      $size: "large",
      width: "100%"
    },
    "data-test": "add-to-cart",
    isLoading: loading,
    onClick: function onClick() {
      if (!loading && !outOfStock) {
        add(quantityPicker.amount);
      }
    },
    disabled: outOfStock || !product.isVisible || product.price.regular === 0 || disableProductForHit
  }, translations.addToCart);
  var availabilityInfo = product.availability.level && (outOfStock || lowAvailabilityLevel || !product.isVisible) && __jsx(_Box["default"], null, __jsx(_Box["default"], {
    sx: {
      font: "body2",
      color: "main",
      display: qtyWithButton ? "none" : "block"
    }
  }, translations.quantity), __jsx(_Box["default"], {
    sx: {
      font: (_additionalStyles$qty = additionalStyles === null || additionalStyles === void 0 ? void 0 : additionalStyles.qtyLabelFont) !== null && _additionalStyles$qty !== void 0 ? _additionalStyles$qty : "xs",
      color: (_additionalStyles$qty2 = additionalStyles === null || additionalStyles === void 0 ? void 0 : additionalStyles.qtyLabelColor) !== null && _additionalStyles$qty2 !== void 0 ? _additionalStyles$qty2 : "orange"
    }
  }, outOfStock || !product.isVisible ? availabilityDate !== null ? availabilityDate : translations.outOfStock : translations.lastItemsInStock));
  var labelStyles = {
    backgroundColor: "negative",
    color: "white",
    width: 110,
    height: 26,
    borderRadius: 100,
    font: "xs",
    textAlign: "center",
    marginY: "s7",
    textDecoration: "uppercase"
  };
  var arrowsForMobile = isMobile && props.arrowsForMobile;
  var _useState2 = (0, _react.useState)(false),
    photoGridVisible = _useState2[0],
    setPhotoGridVisible = _useState2[1];
  (0, _react.useEffect)(function () {
    if (isMobile) {
      setPhotoGridVisible(false);
    } else if (photoGrid) {
      setPhotoGridVisible(true);
    }
  }, [isMobile]);
  var showLowestPrice = __webpack_require__.g.__appConfig__.showLowestPrice && language.language ? (0, _showLowestPrice["default"])({
    showLowestPriceId: parseInt(__webpack_require__.g.__appConfig__.showLowestPrice[language.language]),
    price: product.price
  }) : false;
  var ref = (0, _react.useRef)(null);
  var _useState3 = (0, _react.useState)(false),
    showProducent = _useState3[0],
    setShowProducent = _useState3[1];
  var Producer = function Producer() {
    var _showProducent$addres, _showProducent$addres2, _showProducent$email;
    return showProducent && __jsx(_DialogUi["default"], {
      isOpen: !!showProducent,
      anchoredTo: ref,
      onClose: function onClose() {
        if (!showProducent) return;
        setShowProducent(false);
      },
      withScrollBar: true,
      sx: {
        minWidth: 300,
        minHeight: 100,
        height: "auto",
        width: "auto",
        position: "relative"
      }
    }, showProducent && __jsx(_Box["default"], {
      sx: {
        background: "white",
        border: "2px solid #ccd4da",
        borderRadius: 8,
        padding: 20
      }
    }, __jsx(_Box["default"], {
      sx: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center"
      }
    }, __jsx(_Box["default"], {
      as: "span",
      sx: {
        font: "base_sans_bold",
        color: "producerGreyLight",
        textTransform: "uppercase"
      }
    }, translations.producer, " ", showProducent.producer), __jsx(_Box["default"], {
      onClick: function onClick() {
        return setShowProducent(null);
      }
    }, __jsx(CloseIcon, null))), __jsx(_Box["default"], {
      sx: {
        marginTop: 10,
        color: "producerGrey"
      }
    }, __jsx(_Box["default"], null, " ", showProducent === null || showProducent === void 0 ? void 0 : (_showProducent$addres = showProducent.address) === null || _showProducent$addres === void 0 ? void 0 : (_showProducent$addres2 = _showProducent$addres.split("\n")) === null || _showProducent$addres2 === void 0 ? void 0 : _showProducent$addres2.map(function (line, index) {
      return __jsx(_react["default"].Fragment, {
        key: index
      }, line, __jsx("br", null));
    })), __jsx(_Box["default"], {
      sx: {
        marginTop: 2,
        a: {
          color: "producerGrey",
          outline: "none"
        }
      }
    }, showProducent !== null && showProducent !== void 0 && (_showProducent$email = showProducent.email) !== null && _showProducent$email !== void 0 && _showProducent$email.includes("@") ? __jsx(_react["default"].Fragment, null, "e-mail:", " ", __jsx("a", {
      href: "mailto:".concat(showProducent === null || showProducent === void 0 ? void 0 : showProducent.email)
    }, showProducent.email)) : __jsx(_react["default"].Fragment, null, "www:", " ", __jsx("a", {
      href: "http://".concat(showProducent === null || showProducent === void 0 ? void 0 : showProducent.email),
      target: "_blank"
    }, showProducent.email))), (showProducent === null || showProducent === void 0 ? void 0 : showProducent.phone) && __jsx(_Box["default"], null, translations.phone.toLowerCase(), ": ", showProducent.phone))));
  };
  return __jsx(_Box["default"], {
    sx: {
      mt: [0, null, null, "s8", "s10"]
    }
  }, __jsx(Producer, null), __jsx(_Container["default"], {
    margin: [0, "containerMargin"]
  }, __jsx(_Grid["default"], {
    cols: 20
  }, __jsx(_Box["default"], {
    sx: {
      gridColumnStart: ["span 20", null, null, "span 12"],
      mb: ["s8", null, null, 0]
    }
  }, photoGridVisible ? __jsx(_Grid["default"], {
    cols: productImages.length > 3 ? 2 : 1,
    gap: "s5"
  }, productImages.map(function (image) {
    return __jsx(_ImageZoomableUi["default"], {
      zoom: productImages.length > 3 ? 3 : 2
    }, __jsx(_Image["default"], {
      overlay: true,
      overlayOpacity: imageOverlayOpacity,
      image: image,
      quality: __webpack_require__.g.__appConfig__.productThumbnailsQuality,
      cloudflareEnabled: __webpack_require__.g.__appConfig__.productThumbnailsCloudflareEnabled,
      roundness: roundness,
      zoomable: true,
      zoom: productImages.length > 3 ? 3 : 2
    }));
  })) : __jsx(_Box["default"], {
    sx: {
      pb: "100%",
      position: "relative",
      mb: "s3"
    }
  }, __jsx(_ImageSliderUi["default"], {
    controller: imageSlider,
    isMobile: isMobile,
    arrowsForMobile: arrowsForMobile,
    photogridMobile: photoGrid,
    sx: {
      position: "absolute",
      width: "100%",
      height: "100%",
      top: 0,
      left: 0,
      $image: {
        $objectFit: "contain",
        __props: {
          cloudflareEnabled: __webpack_require__.g.__appConfig__.bigImageCloudflareEnabled,
          quality: __webpack_require__.g.__appConfig__.bigImageQuality,
          sizes: "(max-width: 1535px) and (min-width: 960px) 768px, (max-width: 960px) and (min-width: 10px) 100vw, 1024px"
        }
      }
    }
  }), __jsx(_Box["default"], {
    sx: {
      background: "rgba(0, 0, 0, 0.03)",
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      zIndex: 1,
      pointerEvents: "none"
    }
  })), thumbnails && __jsx(_useSelectScrollableStack["default"], {
    controller: thumbnails,
    previousButton: function previousButton(_ref) {
      var isAtStart = _ref.isAtStart;
      return {
        button: /*#__PURE__*/_react["default"].cloneElement(buttonArrowLeft, {
          sx: {
            opacity: isAtStart ? 0 : 1,
            transition: "opacity .15s",
            pointerEvents: isAtStart ? "none" : "default"
          },
          "data-test": "left-arrow-small-image-slider"
        }),
        offset: -22
      };
    },
    nextButton: function nextButton(_ref2) {
      var isAtEnd = _ref2.isAtEnd;
      return {
        button: /*#__PURE__*/_react["default"].cloneElement(buttonArrowRight, {
          sx: {
            opacity: isAtEnd ? 0 : 1,
            transition: "opacity .10s",
            pointerEvents: isAtEnd ? "none" : "default"
          },
          "data-test": "right-arrow-small-image-slider"
        }),
        offset: -22
      };
    },
    sx: {
      $itemSize: 80,
      $gap: 4,
      $floatingElement: {
        height: "2px",
        bg: "main"
      }
    }
  }, __jsx(_Selectable["default"], {
    sx: {
      height: "80px",
      width: "80px",
      display: arrowsForMobile ? "none" : "block",
      img: {
        height: "80px",
        width: "80px"
      }
    }
  }, function (_ref3) {
    var option = _ref3.option;
    return __jsx(_Image["default"], {
      overlay: true,
      image: option,
      quality: __webpack_require__.g.__appConfig__.productThumbnailsQuality,
      cloudflareEnabled: __webpack_require__.g.__appConfig__.productThumbnailsCloudflareEnabled,
      sx: {
        height: "80px",
        width: "80px",
        cursor: "pointer"
      },
      minified: true
    });
  }))), __jsx(_Box["default"], {
    sx: {
      gridColumnStart: ["span 20", null, null, "span 1"]
    }
  }), __jsx(_Box["default"], {
    sx: {
      gridColumnStart: ["span 20", null, null, "span 7"]
    }
  }, currentProductIsHit && __jsx(_HitProductPage["default"], null), __jsx(_Container["default"], {
    margin: ["containerMargin", null, null, 15, 0]
  }, __jsx(_Box["default"], {
    sx: {
      display: "flex",
      justifyContent: productCategory !== null && productCategory !== void 0 && productCategory.name ? "space-between" : "flex-end",
      alignContent: "center"
    }
  }, (productCategory === null || productCategory === void 0 ? void 0 : productCategory.name) && __jsx(Link, {
    route: "category-page",
    params: productCategory
  }, __jsx(_LinkRaw["default"], {
    sx: {
      font: ["xs", null, null, qtyWithButton ? "xs" : "xs_underline"],
      color: "main",
      svg: {
        width: 15,
        height: 15,
        position: "relative",
        top: 3
      }
    }
  }, __jsx(_Box["default"], {
    sx: {
      mb: qtyWithButton ? "s7" : "s5"
    }
  }, __jsx(ChevronLeftIcon, null), __jsx(_Box["default"], {
    as: "span",
    sx: {
      ml: 5
    }
  }, productCategory.name)))), __jsx(_Box["default"], {
    sx: {
      color: isInWishlist ? "negative" : "main",
      width: 16,
      mr: "s6",
      alignSelf: "center"
    },
    "data-test": "wishlist"
  }, token ? __jsx(_Box["default"], {
    sx: {
      cursor: "pointer"
    },
    onClick: function onClick() {
      isInWishlist ? removeFromWishlist(product.sku) : addToWishlist(product.sku);
    }
  }, isInWishlist ? wishlistIcon : wishlistOutlineIcon) : __jsx(_Box["default"], null, __jsx(_Tooltip["default"], {
    text: translations.wishlistTooltip
  }, wishlistOutlineIcon)))), product.labelText && __jsx(_Box["default"], {
    sx: {
      font: "heading3",
      color: "positive"
    }
  }, translations["new"]), currentProductIsHit && sale && (0, _isDiscount["default"])(product.price.special || product.price.regular, sale.price) && __jsx(_Box["default"], {
    sx: {
      font: "heading3",
      color: "negative"
    }
  }, translations.sale, " -", (0, _percentDecrease["default"])(product.price.special || product.price.regular, sale.price), "%"), !currentProductIsHit && (0, _isDiscount["default"])(product.price.regular, product.price.special) && __jsx(_Box["default"], {
    sx: {
      font: "heading3",
      color: "negative"
    }
  }, translations.sale, " -", (0, _percentDecrease["default"])(product.price.regular, product.price.special), "%"), __jsx(_Box["default"], {
    as: "h1",
    sx: {
      font: "l_normal",
      color: "main"
    }
  }, product.name), __jsx(_Box["default"], {
    sx: {
      font: (_additionalStyles$sku = additionalStyles === null || additionalStyles === void 0 ? void 0 : additionalStyles.skuFont) !== null && _additionalStyles$sku !== void 0 ? _additionalStyles$sku : "s_sans",
      textTransform: "uppercase",
      color: additionalStyles !== null && additionalStyles !== void 0 && additionalStyles.skuColor ? additionalStyles === null || additionalStyles === void 0 ? void 0 : additionalStyles.skuColor : qtyWithButton ? "main" : "neutral700",
      mt: qtyWithButton ? "s5" : 0
    }
  }, translations.productCode, " ", product.sku), (currentProductIsHit || product.promoLabelIndex !== undefined) && __jsx(_ButtonRaw["default"], {
    sx: _objectSpread(_objectSpread({}, labelStyles), {}, {
      mr: "s5"
    })
  }, currentProductIsHit ? translations.hitDay : promoLabels[product.promoLabelIndex]), currentProductGotAdditionalLabel && __jsx(_ButtonRaw["default"], {
    sx: _objectSpread({}, labelStyles)
  }, translations.additionalPromoLabel), showProducerAndCollectionInfo && __jsx(_Box["default"], {
    sx: {
      mt: "s7",
      display: "flex",
      flexDirection: ["column", null, "row"]
    }
  }, __jsx(_Box["default"], {
    sx: {
      display: product.producer ? "flex" : "none",
      font: "xs_caps",
      color: "main",
      height: 35,
      alignItems: "center"
    }
  }, __jsx(_Box["default"], {
    sx: {
      height: "100%",
      pt: 10
    }
  }, translations.producer, ":"), __jsx(_CollectionButton["default"], {
    ref: ref,
    setShowProducent: setShowProducent,
    product: product,
    isCollection: false,
    rootCategory: rootCategories[language.language],
    brandCategory: brandCategories[language.language]
  })), __jsx(_Box["default"], {
    sx: {
      display: product.collection.name ? "flex" : "none",
      font: "xs_caps",
      color: "main",
      height: 35,
      alignItems: "center",
      ml: product.producer ? [0, null, "s8"] : 0,
      mt: ["s6", null, 0]
    }
  }, __jsx(_Box["default"], {
    sx: {
      height: "100%",
      pt: 10
    }
  }, translations.dajar_collection, ":"), __jsx(_CollectionButton["default"], {
    product: product,
    isCollection: true,
    rootCategory: rootCategories[language.language],
    brandCategory: brandCategories[language.language]
  }))), __jsx(_Box["default"], {
    sx: {
      mb: qtyWithButton ? ["s9", null, null, "s11_2"] : "s9",
      mt: "s7"
    }
  }, __jsx(_Box["default"], {
    as: "p",
    sx: {
      font: qtyWithButton ? "xxl_sans" : "heading3",
      color: "main"
    }
  }, sale !== null && sale !== void 0 && sale.price || product.price.special ? __jsx(_Box["default"], {
    as: "span",
    sx: {
      textDecorationLine: "line-through",
      font: "l_normal"
    }
  }, priceWithCurrency(sale !== null && sale !== void 0 && sale.price && product.price.special ? product.price.special : product.price.regular)) : priceWithCurrency(product.price.regular), (language === null || language === void 0 ? void 0 : language.language) === "de" && __jsx(_Box["default"], {
    sx: {
      font: "xs",
      color: "neutral700",
      mt: "s4",
      a: {
        color: "neutral700",
        textDecoration: "none"
      }
    },
    dangerouslySetInnerHTML: {
      __html: translations.priceIncludesTax
    }
  })), (product.price.special || (sale === null || sale === void 0 ? void 0 : sale.price)) && __jsx(_Box["default"], {
    as: "p",
    sx: {
      font: qtyWithButton ? "xxl_sans" : "heading3",
      color: "negative"
    }
  }, priceWithCurrency((_sale$price = sale === null || sale === void 0 ? void 0 : sale.price) !== null && _sale$price !== void 0 ? _sale$price : product.price.special)), showLowestPrice && __jsx(_react["default"].Fragment, null, __jsx(_Box["default"], {
    sx: {
      font: "xs",
      mt: "s6"
    }
  }, translations.lowestPrice, ":", " ", priceWithCurrency(product.price.lowest)), productFromOutlet && __jsx(_Box["default"], {
    sx: {
      font: "xs",
      mt: "s6"
    }
  }, translations.offerValid)), product.epoints && __jsx(_Box["default"], {
    sx: {
      mt: "s5",
      backgroundColor: "lightOrange",
      color: "orange",
      font: "xs",
      borderRadius: "100px",
      display: "inline-block",
      py: "s3",
      px: "s6"
    }
  }, "+", product.epoints, " ", translations.bonusPoints)), __jsx(_Box["default"], {
    sx: {
      mb: options.length > 0 && qtyWithButton ? [0, null, null, "s12"] : 0
    }
  }, /*#__PURE__*/_react["default"].cloneElement(optionsSelector, {
    options: options,
    selectedValues: selectedValues
  })), options.find(function (option) {
    return option.showAsteriskInfo;
  }) && __jsx(_Box["default"], {
    sx: {
      font: "xs",
      color: "neutral700"
    }
  }, "* ", translations.productAsteriskInfo), language.language === __webpack_require__.g.__appConfig__.shopOffGB ? __jsx(_Box["default"], {
    sx: {
      color: "main",
      font: "xs"
    }
  }, translations.brexit) : __jsx(_react["default"].Fragment, null, qtyWithButton && availabilityInfo, __jsx(_Box["default"], {
    sx: {
      display: "flex",
      alignItems: "center",
      justifyContent: qtyWithButton ? "left" : "space-between",
      mb: "s7",
      mt: qtyWithButton ? "s7" : "s9"
    }
  }, __jsx(_Box["default"], {
    sx: {
      display: "flex",
      flexDirection: "column",
      justifyContent: qtyWithButton ? "left" : "space-around"
    }
  }, !qtyWithButton && !currentProductIsHit && availabilityInfo, currentProductIsHit && __jsx(_react["default"].Fragment, null, __jsx(_Box["default"], {
    sx: {
      font: "s_sans",
      color: "black"
    }
  }, translations.quantity), " ", __jsx(_Box["default"], {
    sx: {
      font: "xs",
      color: "negative500"
    }
  }, translations.onlyLeftInStock))), __jsx(_Box["default"], {
    sx: {
      minWidth: qtyWithButton ? 158 : 140
    }
  }, /*#__PURE__*/_react["default"].cloneElement(props.quantityPicker, {
    controller: quantityPicker
  })), qtyWithButton && addToCartButton), !qtyWithButton && addToCartButton, (0, _hasStoreAdditionalFunctionalities["default"])(language) && !outOfStock && __jsx(_Box["default"], {
    sx: {
      font: "xs",
      color: "main",
      mt: "s3",
      pb: "s7"
    }
  }, translations.deliveryTime), currentProductIsHit && __jsx(_Box["default"], {
    sx: {
      font: "xs",
      mt: "s6"
    }
  }, translations.maxAvailableQtyHit), showAdditionalFeeInfo && __jsx(_Box["default"], {
    sx: {
      font: "body",
      color: "main",
      mt: "s9",
      pb: "s7",
      borderBottomStyle: "solid",
      borderBottomWidth: "1px",
      borderBottomColor: showDescriptionAsAccordion ? "white" : "neutral500"
    }
  }, translations.freeDeliveryInfo), __webpack_require__.g.__appConfig__.deliveryInfoEnabled && __jsx(_Box["default"], {
    sx: {
      font: "body2",
      color: "main",
      mt: "s6"
    }
  }, shippingLimitMinusPrice <= 0 ? __jsx(_Box["default"], null, translations.freeShipping) : __jsx(_Box["default"], null, translations.shippingPrice), __jsx(_Box["default"], null, translations.shippingTime), __webpack_require__.g.__appConfig__.packageCarryingInfoEnabled && __jsx(_Box["default"], null, translations.carryPackage))), showDescriptionAsAccordion && __jsx(_ProductDescriptionAccordion["default"], {
    productInfo: product.info,
    translations: translations,
    qtyWithButton: qtyWithButton,
    accordionLabelFont: additionalStyles === null || additionalStyles === void 0 ? void 0 : additionalStyles.accordionLabelFont
  }), !qtyWithButton && __webpack_require__.g.__appConfig__.pdpCatalogPriceVisibility[language.language] === 1 && __jsx(_Box["default"], {
    sx: {
      font: "xs",
      color: "neutral700",
      mt: "s7"
    }
  }, translations.catalogPrice, " ", priceWithCurrency((0, _countCatalogPrice["default"])(product.price.regular, 0.7))))))), !showDescriptionAsAccordion && __jsx(_ProductDescription2Columns["default"], {
    productInfo: product === null || product === void 0 ? void 0 : product.info
  }));
};
var _default = ProductHead;
exports.Z = _default;

/***/ }),

/***/ 747:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _react = _interopRequireWildcard(__webpack_require__(34885));
var _Box = _interopRequireDefault(__webpack_require__(40300));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) { "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); } return f; })(e, t); }
var __jsx = _react["default"].createElement;
var Tooltip = function Tooltip(props) {
  var children = props.children,
    text = props.text;
  var _useState = (0, _react.useState)(false),
    isActive = _useState[0],
    setActive = _useState[1];
  var _useState2 = (0, _react.useState)(false),
    tooltipDisplayed = _useState2[0],
    setTooltipDisplayed = _useState2[1];
  var closeTooltip = function closeTooltip() {
    setTooltipDisplayed(true);
    setActive(false);
  };
  (0, _react.useEffect)(function () {
    var close = isActive && !tooltipDisplayed && setTimeout(function () {
      closeTooltip();
    }, 3000);
    return function () {
      clearInterval(close);
    };
  }, [isActive]);
  return tooltipDisplayed ? __jsx(_Box["default"], null, children) : __jsx(_Box["default"], {
    sx: {
      position: "relative",
      zIndex: 1,
      cursor: tooltipDisplayed ? "auto" : "pointer"
    },
    onClick: function onClick() {
      return setActive(true);
    }
  }, isActive && __jsx(_Box["default"], {
    sx: {
      position: "absolute",
      zIndex: 2,
      font: "xs",
      color: "white",
      borderRadius: 5,
      p: "s5",
      backgroundColor: "active",
      top: "110%",
      minWidth: ["100px", null, null, "200px"],
      left: ["-90px", null, null, "-168px"]
    },
    onClick: function onClick() {
      return closeTooltip();
    }
  }, __jsx(_Box["default"], {
    as: "span",
    sx: {
      position: "absolute",
      bottom: "100%",
      right: "10%",
      ml: "-5px",
      borderWidth: "5px",
      borderStyle: "solid",
      borderLeftColor: "transparent",
      borderRightColor: "transparent",
      borderBottomColor: "active",
      borderTopColor: "transparent"
    }
  }), text), __jsx(_Box["default"], {
    sx: {
      position: "relative",
      zIndex: 100
    }
  }, children));
};
var _default = Tooltip;
exports["default"] = _default;

/***/ }),

/***/ 36909:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _react = _interopRequireDefault(__webpack_require__(34885));
var _totalPrice = _interopRequireDefault(__webpack_require__(26109));
var countCatalogPrice = function countCatalogPrice(price) {
  var percent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1.2;
  return (0, _totalPrice["default"])(price / percent, 1);
};
var _default = countCatalogPrice;
exports["default"] = _default;

/***/ }),

/***/ 16388:
/***/ (function(__unused_webpack_module, exports) {



Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _default = function _default(product, text) {
  var _product$info;
  var technicalData = product === null || product === void 0 ? void 0 : (_product$info = product.info) === null || _product$info === void 0 ? void 0 : _product$info.technicalData;
  var availability = technicalData.find(function (data) {
    return (data === null || data === void 0 ? void 0 : data.label) === "available_from";
  });
  if (availability) {
    var datePart = availability.name.split(" ")[0].split("-");
    return text + ": " + datePart[1] + "." + datePart[0];
  }
  return null;
};
exports["default"] = _default;

/***/ }),

/***/ 30999:
/***/ (function(__unused_webpack_module, exports) {

var __webpack_unused_export__;


__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var getSkusFromProductLinks = function getSkusFromProductLinks(productLinks) {
  var typeLink = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "upsell";
  return productLinks === null || productLinks === void 0 ? void 0 : productLinks.filter(function (productLink) {
    return productLink.linkType === typeLink;
  }).map(function (productLink) {
    return productLink.sku;
  }).toString();
};
var _default = getSkusFromProductLinks;
exports.Z = _default;

/***/ }),

/***/ 59926:
/***/ (function(__unused_webpack_module, exports) {



Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = exports.removeSpecificCharactersFromString = void 0;
var removeSpecificCharactersFromString = function removeSpecificCharactersFromString(_ref) {
  var _ref$string = _ref.string,
    string = _ref$string === void 0 ? "" : _ref$string,
    _ref$removeSpaces = _ref.removeSpaces,
    removeSpaces = _ref$removeSpaces === void 0 ? false : _ref$removeSpaces,
    _ref$spaceChar = _ref.spaceChar,
    spaceChar = _ref$spaceChar === void 0 ? "_" : _ref$spaceChar;
  if (!string) return "";
  var stringWithoutSpecificChars = string.replace(/--/g, "-").replace(/ą/g, "a").replace(/Ą/g, "A").replace(/ć/g, "c").replace(/Ć/g, "C").replace(/ę/g, "e").replace(/Ę/g, "E").replace(/ł/g, "l").replace(/Ł/g, "L").replace(/ń/g, "n").replace(/Ń/g, "N").replace(/ó/g, "o").replace(/Ó/g, "O").replace(/ś/g, "s").replace(/Ś/g, "S").replace(/ż/g, "z").replace(/Ż/g, "Z").replace(/ź/g, "z").replace(/Ź/g, "Z");
  if (!removeSpaces) {
    return stringWithoutSpecificChars;
  }
  return stringWithoutSpecificChars.replace(/\s/g, spaceChar);
};
exports.removeSpecificCharactersFromString = removeSpecificCharactersFromString;
var _default = removeSpecificCharactersFromString;
exports["default"] = _default;

/***/ }),

/***/ 60111:
/***/ (function(__unused_webpack_module, exports) {



Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var isGlobalEnvEnabled = function isGlobalEnvEnabled(_ref) {
  var globalEnv = _ref.globalEnv,
    language = _ref.language,
    _ref$returnValue = _ref.returnValue,
    returnValue = _ref$returnValue === void 0 ? false : _ref$returnValue;
  if ((globalEnv === null || globalEnv === void 0 ? void 0 : globalEnv[language === null || language === void 0 ? void 0 : language.language]) === undefined) {
    return false;
  }
  var globalValue = parseInt(globalEnv === null || globalEnv === void 0 ? void 0 : globalEnv[language === null || language === void 0 ? void 0 : language.language]);
  return returnValue ? globalValue : Boolean(globalValue);
};
var _default = isGlobalEnvEnabled;
exports["default"] = _default;

/***/ }),

/***/ 85799:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _react = _interopRequireDefault(__webpack_require__(34885));
var parseProductDescription = function parseProductDescription(text) {
  if (!text) return "";
  var textContainsNewLineChar = text.includes("\n");
  var parsedDescription = "";
  if (!textContainsNewLineChar) {
    return text;
  } else {
    if (text.includes("<br>") || text.includes("<h2>")) {
      parsedDescription = text.replace(/\n/gi, "");
    } else {
      parsedDescription = text.replace(/\n/gi, "<br />");
    }
  }
  return parsedDescription;
};
var _default = parseProductDescription;
exports["default"] = _default;

/***/ }),

/***/ 21052:
/***/ (function(__unused_webpack_module, exports) {



Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var mapBrandInfo = function mapBrandInfo(response) {
  if (!response) return false;
  var svgLogo = "";
  var description = [];
  response.data.body.forEach(function (data) {
    if (data.slice_type === "brandlogo") {
      var _data$primary;
      (_data$primary = data.primary) === null || _data$primary === void 0 ? void 0 : _data$primary.svglogo.forEach(function (logoPart) {
        return svgLogo += logoPart.text;
      });
    }
    if (data.slice_type === "text") {
      description.push(data.primary.text[0]);
    }
  });
  return {
    title: response.data.title[0].text,
    description: description,
    logo: svgLogo.replace('"', '"')
  };
};
var _default = mapBrandInfo;
exports["default"] = _default;

/***/ }),

/***/ 95842:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _image = _interopRequireDefault(__webpack_require__(43733));
var mapCollectionInfo = function mapCollectionInfo(response) {
  var _response$data$title$, _response$data$title, _response$data$title$2, _response$data$descri, _response$data$descri2, _response$data$descri3, _response$data$body$, _response$data, _response$data$body, _response$data$body$2, _response$data$body$3, _response$data$body$4, _response$data$body$5, _response$data$body$6;
  if (!response) return false;
  return {
    title: (_response$data$title$ = (_response$data$title = response.data.title) === null || _response$data$title === void 0 ? void 0 : (_response$data$title$2 = _response$data$title[0]) === null || _response$data$title$2 === void 0 ? void 0 : _response$data$title$2.text) !== null && _response$data$title$ !== void 0 ? _response$data$title$ : "",
    description: (_response$data$descri = (_response$data$descri2 = response.data.description) === null || _response$data$descri2 === void 0 ? void 0 : (_response$data$descri3 = _response$data$descri2[0]) === null || _response$data$descri3 === void 0 ? void 0 : _response$data$descri3.text) !== null && _response$data$descri !== void 0 ? _response$data$descri : "",
    banners: (_response$data$body$ = (_response$data = response.data) === null || _response$data === void 0 ? void 0 : (_response$data$body = _response$data.body) === null || _response$data$body === void 0 ? void 0 : (_response$data$body$2 = _response$data$body[0]) === null || _response$data$body$2 === void 0 ? void 0 : (_response$data$body$3 = _response$data$body$2.items) === null || _response$data$body$3 === void 0 ? void 0 : _response$data$body$3.map(function (banner) {
      var _banner$title$0$text, _banner$title, _banner$title$;
      return {
        title: (_banner$title$0$text = (_banner$title = banner.title) === null || _banner$title === void 0 ? void 0 : (_banner$title$ = _banner$title[0]) === null || _banner$title$ === void 0 ? void 0 : _banner$title$.text) !== null && _banner$title$0$text !== void 0 ? _banner$title$0$text : "",
        image: (0, _image["default"])(banner.image)
      };
    })) !== null && _response$data$body$ !== void 0 ? _response$data$body$ : [],
    text: (_response$data$body$4 = (_response$data$body$5 = response.data.body[1]) === null || _response$data$body$5 === void 0 ? void 0 : (_response$data$body$6 = _response$data$body$5.primary) === null || _response$data$body$6 === void 0 ? void 0 : _response$data$body$6.text) !== null && _response$data$body$4 !== void 0 ? _response$data$body$4 : ""
  };
};
var _default = mapCollectionInfo;
exports["default"] = _default;

/***/ }),

/***/ 64426:
/***/ (function(__unused_webpack_module, exports) {



Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var diacritics = [{
  base: "A",
  letters: "A\u24B6\uFF21\xC0\xC1\xC2\u1EA6\u1EA4\u1EAA\u1EA8\xC3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\xC4\u01DE\u1EA2\xC5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F"
}, {
  base: "AA",
  letters: "\uA732"
}, {
  base: "AE",
  letters: "\xC6\u01FC\u01E2"
}, {
  base: "AO",
  letters: "\uA734"
}, {
  base: "AU",
  letters: "\uA736"
}, {
  base: "AV",
  letters: "\uA738\uA73A"
}, {
  base: "AY",
  letters: "\uA73C"
}, {
  base: "B",
  letters: "B\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181"
}, {
  base: "C",
  letters: "C\u24B8\uFF23\u0106\u0108\u010A\u010C\xC7\u1E08\u0187\u023B\uA73E"
}, {
  base: "D",
  letters: "D\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779\xD0"
}, {
  base: "DZ",
  letters: "\u01F1\u01C4"
}, {
  base: "Dz",
  letters: "\u01F2\u01C5"
}, {
  base: "E",
  letters: "E\u24BA\uFF25\xC8\xC9\xCA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\xCB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E"
}, {
  base: "F",
  letters: "F\u24BB\uFF26\u1E1E\u0191\uA77B"
}, {
  base: "G",
  letters: "G\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E"
}, {
  base: "H",
  letters: "H\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D"
}, {
  base: "I",
  letters: "I\u24BE\uFF29\xCC\xCD\xCE\u0128\u012A\u012C\u0130\xCF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197"
}, {
  base: "J",
  letters: "J\u24BF\uFF2A\u0134\u0248"
}, {
  base: "K",
  letters: "K\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2"
}, {
  base: "L",
  letters: "L\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780"
}, {
  base: "LJ",
  letters: "\u01C7"
}, {
  base: "Lj",
  letters: "\u01C8"
}, {
  base: "M",
  letters: "M\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C"
}, {
  base: "N",
  letters: "N\u24C3\uFF2E\u01F8\u0143\xD1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4"
}, {
  base: "NJ",
  letters: "\u01CA"
}, {
  base: "Nj",
  letters: "\u01CB"
}, {
  base: "O",
  letters: "O\u24C4\uFF2F\xD2\xD3\xD4\u1ED2\u1ED0\u1ED6\u1ED4\xD5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\xD6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\xD8\u01FE\u0186\u019F\uA74A\uA74C"
}, {
  base: "OI",
  letters: "\u01A2"
}, {
  base: "OO",
  letters: "\uA74E"
}, {
  base: "OU",
  letters: "\u0222"
}, {
  base: "OE",
  letters: "\x8C\u0152"
}, {
  base: "oe",
  letters: "\x9C\u0153"
}, {
  base: "P",
  letters: "P\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754"
}, {
  base: "Q",
  letters: "Q\u24C6\uFF31\uA756\uA758\u024A"
}, {
  base: "R",
  letters: "R\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782"
}, {
  base: "S",
  letters: "S\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784"
}, {
  base: "T",
  letters: "T\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786"
}, {
  base: "TZ",
  letters: "\uA728"
}, {
  base: "U",
  letters: "U\u24CA\uFF35\xD9\xDA\xDB\u0168\u1E78\u016A\u1E7A\u016C\xDC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244"
}, {
  base: "V",
  letters: "V\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245"
}, {
  base: "VY",
  letters: "\uA760"
}, {
  base: "W",
  letters: "W\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72"
}, {
  base: "X",
  letters: "X\u24CD\uFF38\u1E8A\u1E8C"
}, {
  base: "Y",
  letters: "Y\u24CE\uFF39\u1EF2\xDD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE"
}, {
  base: "Z",
  letters: "Z\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762"
}, {
  base: "a",
  letters: "a\u24D0\uFF41\u1E9A\xE0\xE1\xE2\u1EA7\u1EA5\u1EAB\u1EA9\xE3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\xE4\u01DF\u1EA3\xE5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250"
}, {
  base: "aa",
  letters: "\uA733"
}, {
  base: "ae",
  letters: "\xE6\u01FD\u01E3"
}, {
  base: "ao",
  letters: "\uA735"
}, {
  base: "au",
  letters: "\uA737"
}, {
  base: "av",
  letters: "\uA739\uA73B"
}, {
  base: "ay",
  letters: "\uA73D"
}, {
  base: "b",
  letters: "b\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253"
}, {
  base: "c",
  letters: "c\u24D2\uFF43\u0107\u0109\u010B\u010D\xE7\u1E09\u0188\u023C\uA73F\u2184"
}, {
  base: "d",
  letters: "d\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A"
}, {
  base: "dz",
  letters: "\u01F3\u01C6"
}, {
  base: "e",
  letters: "e\u24D4\uFF45\xE8\xE9\xEA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\xEB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD"
}, {
  base: "f",
  letters: "f\u24D5\uFF46\u1E1F\u0192\uA77C"
}, {
  base: "g",
  letters: "g\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F"
}, {
  base: "h",
  letters: "h\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265"
}, {
  base: "hv",
  letters: "\u0195"
}, {
  base: "i",
  letters: "i\u24D8\uFF49\xEC\xED\xEE\u0129\u012B\u012D\xEF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131"
}, {
  base: "j",
  letters: "j\u24D9\uFF4A\u0135\u01F0\u0249"
}, {
  base: "k",
  letters: "k\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3"
}, {
  base: "l",
  letters: "l\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747"
}, {
  base: "lj",
  letters: "\u01C9"
}, {
  base: "m",
  letters: "m\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F"
}, {
  base: "n",
  letters: "n\u24DD\uFF4E\u01F9\u0144\xF1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5"
}, {
  base: "nj",
  letters: "\u01CC"
}, {
  base: "o",
  letters: "o\u24DE\uFF4F\xF2\xF3\xF4\u1ED3\u1ED1\u1ED7\u1ED5\xF5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\xF6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\xF8\u01FF\u0254\uA74B\uA74D\u0275"
}, {
  base: "oi",
  letters: "\u01A3"
}, {
  base: "ou",
  letters: "\u0223"
}, {
  base: "oo",
  letters: "\uA74F"
}, {
  base: "p",
  letters: "p\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755"
}, {
  base: "q",
  letters: "q\u24E0\uFF51\u024B\uA757\uA759"
}, {
  base: "r",
  letters: "r\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783"
}, {
  base: "s",
  letters: "s\u24E2\uFF53\xDF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B"
}, {
  base: "t",
  letters: "t\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787"
}, {
  base: "tz",
  letters: "\uA729"
}, {
  base: "u",
  letters: "u\u24E4\uFF55\xF9\xFA\xFB\u0169\u1E79\u016B\u1E7B\u016D\xFC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289"
}, {
  base: "v",
  letters: "v\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C"
}, {
  base: "vy",
  letters: "\uA761"
}, {
  base: "w",
  letters: "w\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73"
}, {
  base: "x",
  letters: "x\u24E7\uFF58\u1E8B\u1E8D"
}, {
  base: "y",
  letters: "y\u24E8\uFF59\u1EF3\xFD\u0177\u1EF9\u0233\u1E8F\xFF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF"
}, {
  base: "z",
  letters: "z\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763"
}, {
  base: "%27",
  letters: "'"
}];
var diacriticsMap = {};
for (var i = 0; i < diacritics.length; i++) {
  var letters = diacritics[i].letters;
  for (var j = 0; j < letters.length; j++) {
    diacriticsMap[letters[j]] = diacritics[i].base;
  }
}
var replaceSpecialCharacters = function replaceSpecialCharacters(refinedText) {
  if (refinedText) {
    return refinedText.replace(/[^\u0000-\u007E]|'/g, function (a) {
      return diacriticsMap[a] || a;
    });
  }
  return refinedText;
};
var _default = replaceSpecialCharacters;
exports["default"] = _default;

/***/ }),

/***/ 31499:
/***/ (function(__unused_webpack_module, exports) {



Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var envProps = {
  0: false,
  1: true,
  2: function _(specialPrice) {
    return specialPrice !== null;
  }
};
var showLowestPrice = function showLowestPrice(_ref) {
  var showLowestPriceId = _ref.showLowestPriceId,
    price = _ref.price;
  if (price.lowest === null || price.lowest === undefined) return false;
  if (showLowestPriceId === 2) {
    return envProps[showLowestPriceId](price.special);
  }
  return envProps[showLowestPriceId];
};
var _default = showLowestPrice;
exports["default"] = _default;

/***/ }),

/***/ 94450:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88349);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34885);
/* harmony import */ var _deosite_components_new_CardWithLabel__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3343);



function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var CardWithLabel = function(props) {
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deosite_components_new_CardWithLabel__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _objectSpread({}, props));
};
/* harmony default export */ __webpack_exports__["Z"] = (CardWithLabel);


/***/ }),

/***/ 69758:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ productPage; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(94986);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(88349);
// EXTERNAL MODULE: ../helpers/dist/langLibrary/index.js
var langLibrary = __webpack_require__(51493);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(34885);
// EXTERNAL MODULE: ../../node_modules/@commerce-ui/core2/useWindowSize.js
var useWindowSize = __webpack_require__(47272);
var useWindowSize_default = /*#__PURE__*/__webpack_require__.n(useWindowSize);
// EXTERNAL MODULE: ./src/theme.js
var theme = __webpack_require__(42223);
// EXTERNAL MODULE: ./src/containers/UI/PageContainer/index.js + 2 modules
var PageContainer = __webpack_require__(73764);
// EXTERNAL MODULE: ./src/components/MetaTags/index.js + 1 modules
var MetaTags = __webpack_require__(39125);
// EXTERNAL MODULE: ../components-new/dist/MetaTags/index.js
var dist_MetaTags = __webpack_require__(36880);
// EXTERNAL MODULE: ../components-new/dist/ProductHead/index.js
var ProductHead = __webpack_require__(5291);
// EXTERNAL MODULE: ./src/components/OptionsSelector/index.js + 1 modules
var OptionsSelector = __webpack_require__(50014);
// EXTERNAL MODULE: ../components-new/dist/buttons/Button/index.js
var Button = __webpack_require__(51586);
// EXTERNAL MODULE: ../components-new/dist/buttons/ButtonArrow/index.js
var ButtonArrow = __webpack_require__(50444);
// EXTERNAL MODULE: ./src/components/quantityPickers/QuantityPicker/index.js
var QuantityPicker = __webpack_require__(72565);
// EXTERNAL MODULE: ./src/icons/cart_for_button.svg
var cart_for_button = __webpack_require__(30554);
;// CONCATENATED MODULE: ./src/icons/heart.svg
var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

function SvgHeart(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/react.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28 28",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/react.createElement("path", {
    d: "M14 26.6c-.3 0-.6-.1-.9-.2-1.8-.9-5.3-2.9-8.3-6.1C1.7 17 .2 13.5.2 9.8c0-4.2 3-8.5 7.9-8.5 2 0 3.7.5 5.1 1.6.3.2.6.5.9.8.3-.3.6-.6.9-.8 1.4-1.1 3-1.6 5.1-1.6C25 1.3 28 5.6 28 9.8c0 3.7-1.6 7.2-4.7 10.6-3 3.2-6.5 5.2-8.3 6.1-.4.1-.7.1-1 .1z"
  })));
}
/* harmony default export */ var heart = (SvgHeart);
;// CONCATENATED MODULE: ./src/icons/heart-light.svg
var heart_light_path;
var heart_light_excluded = ["title", "titleId"];
function heart_light_extends() { return heart_light_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, heart_light_extends.apply(null, arguments); }
function heart_light_objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = heart_light_objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function heart_light_objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

function SvgHeartLight(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = heart_light_objectWithoutProperties(_ref, heart_light_excluded);
  return /*#__PURE__*/react.createElement("svg", heart_light_extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28 28",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, heart_light_path || (heart_light_path = /*#__PURE__*/react.createElement("path", {
    d: "M14 26.6c-.3 0-.6-.1-.9-.2-1.8-.9-5.3-2.9-8.3-6.1C1.7 17 .2 13.5.2 9.8c0-4.2 3-8.5 7.9-8.5 2 0 3.7.5 5.1 1.6.3.2.6.5.9.8.3-.3.6-.6.9-.8 1.4-1.1 3-1.6 5.1-1.6C25 1.3 28 5.6 28 9.8c0 3.7-1.6 7.2-4.7 10.6-3 3.2-6.5 5.2-8.3 6.1-.4.1-.7.1-1 .1zM8.1 2.8c-4 0-6.4 3.6-6.4 7 0 3.3 1.4 6.5 4.3 9.5 2.8 3 6.1 4.9 7.9 5.8.1.1.3.1.4 0 1.7-.9 5.1-2.8 7.9-5.8 2.8-3 4.3-6.2 4.3-9.5 0-3.4-2.2-7-6.4-7-1.7 0-3.1.4-4.2 1.3-.4.3-.8.7-1.2 1.2-.1.2-.4.3-.6.3-.2 0-.4-.1-.6-.3-.4-.5-.8-.9-1.2-1.2-1.2-.9-2.6-1.3-4.2-1.3z"
  })));
}
/* harmony default export */ var heart_light = (SvgHeartLight);
;// CONCATENATED MODULE: ./src/components/ProductHead/index.js










function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var ProductHead_ProductHead = function(props) {
    var propsExt = _objectSpread({}, props, {
        optionsSelector: /*#__PURE__*/ (0,jsx_runtime.jsx)(OptionsSelector/* default */.Z, {}),
        button: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button["default"], {
            leftIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(cart_for_button/* default */.Z, {})
        }),
        buttonArrowLeft: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonArrow.ButtonArrowLeft, {}),
        buttonArrowRight: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonArrow.ButtonArrowRight, {}),
        quantityPicker: /*#__PURE__*/ (0,jsx_runtime.jsx)(QuantityPicker/* default */.Z, {}),
        showProducerAndCollectionInfo: true,
        showDescriptionAsAccordion: false,
        showAdditionalFeeInfo: true,
        wishlistIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(heart, {}),
        wishlistOutlineIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(heart_light, {})
    });
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(ProductHead/* default */.Z, _objectSpread({}, propsExt)));
};
/* harmony default export */ var components_ProductHead = (ProductHead_ProductHead);

// EXTERNAL MODULE: ./src/components/CardsSlider/index.js
var CardsSlider = __webpack_require__(75561);
// EXTERNAL MODULE: ./src/components/ProductBox/index.js
var ProductBox = __webpack_require__(87122);
// EXTERNAL MODULE: ../../node_modules/@commerce-ui/core2/Container/index.js
var Container = __webpack_require__(58709);
var Container_default = /*#__PURE__*/__webpack_require__.n(Container);
// EXTERNAL MODULE: ../../node_modules/@commerce-ui/core2/Box/index.js
var Box = __webpack_require__(40300);
var Box_default = /*#__PURE__*/__webpack_require__.n(Box);
// EXTERNAL MODULE: ../../node_modules/@commerce-ui/core2/Grid/index.js
var Grid = __webpack_require__(98290);
var Grid_default = /*#__PURE__*/__webpack_require__.n(Grid);
// EXTERNAL MODULE: ./src/components/CardWithLabel/index.js
var CardWithLabel = __webpack_require__(94450);
// EXTERNAL MODULE: ../sections/dist/SectionWithConfigurableHeader/index.js
var SectionWithConfigurableHeader = __webpack_require__(88778);
// EXTERNAL MODULE: ../helpers/dist/getSkusFromProductLinks/index.js
var getSkusFromProductLinks = __webpack_require__(30999);
// EXTERNAL MODULE: ../helpers/dist/handleLanguageCharacters/index.js
var handleLanguageCharacters = __webpack_require__(59926);
// EXTERNAL MODULE: ../helpers/dist/cache/index.js
var cache = __webpack_require__(75800);
// EXTERNAL MODULE: ../helpers/dist/getDefaultProductImage/index.js
var getDefaultProductImage = __webpack_require__(705);
// EXTERNAL MODULE: ../../node_modules/prismic-reactjs/dist/prismic-reactjs.js
var prismic_reactjs = __webpack_require__(56410);
// EXTERNAL MODULE: ../components-new/dist/BrandInfo/index.js
var BrandInfo = __webpack_require__(59170);
// EXTERNAL MODULE: ../API/dist/hooks/REST/useProduct/index.js
var useProduct = __webpack_require__(11424);
// EXTERNAL MODULE: ../API/dist/hooks/REST/useProductsFromCollection/index.js
var useProductsFromCollection = __webpack_require__(41410);
// EXTERNAL MODULE: ../API/dist/hooks/REST/useProductsBySkus/index.js
var useProductsBySkus = __webpack_require__(78108);
// EXTERNAL MODULE: ../API/dist/hooks/REST/useCategory/index.js
var useCategory = __webpack_require__(99906);
// EXTERNAL MODULE: ../API/dist/hooks/prismic/usePrismicBrandInfo/index.js
var usePrismicBrandInfo = __webpack_require__(43000);
// EXTERNAL MODULE: ../API/dist/hooks/prismic/usePrismicCollectionInfo/index.js
var usePrismicCollectionInfo = __webpack_require__(11180);
// EXTERNAL MODULE: ../API/dist/hooks/common/useCategoryTree.js
var useCategoryTree = __webpack_require__(28452);
// EXTERNAL MODULE: ../API/dist/hooks/common/useAnalytics4AndCommerceTags.js
var useAnalytics4AndCommerceTags = __webpack_require__(79892);
// EXTERNAL MODULE: ../API/dist/hooks/REST/useSalesmanago.js
var useSalesmanago = __webpack_require__(54569);
// EXTERNAL MODULE: ../API/dist/hooks/common/useProductHeadOptions.js
var useProductHeadOptions = __webpack_require__(71855);
// EXTERNAL MODULE: ../API/dist/hooks/common/LanguageProvider.js
var LanguageProvider = __webpack_require__(8989);
;// CONCATENATED MODULE: ./conf/storeRootCategory.json
var storeRootCategory_namespaceObject = JSON.parse('{"cz":"/dum-a-zahrada","de":"/haus-garten","es":"/casa-y-jardin","fr":"/maison-et-jardin","pl":"/dom-i-ogrod","it":"/casa-giardino","gb":"/home-garden","ro":"/casa-gradina","se":"/hus-och-tradgard","sk":"/dom-a-zahrada"}');
;// CONCATENATED MODULE: ./conf/storeBrandCategory.json
var storeBrandCategory_namespaceObject = JSON.parse('{"cz":"/znacky-a-kolekce","de":"/marken","es":"/marcas","fr":"/marques","pl":"/marki","it":"/marche","gb":"/brands","ro":"/marci","se":"/marken","sk":"/znacky-a-kolekcie"}');
// EXTERNAL MODULE: ../helpers/dist/isGlobalEnvEnabled/index.js
var isGlobalEnvEnabled = __webpack_require__(60111);
// EXTERNAL MODULE: ../components-new/dist/Hit/provider/HitProvider.js
var HitProvider = __webpack_require__(17090);
// EXTERNAL MODULE: ../API/dist/hooks/common/useLoader.js
var useLoader = __webpack_require__(87573);
// EXTERNAL MODULE: ./src/pages/_error.js
var _error = __webpack_require__(98800);
;// CONCATENATED MODULE: ./src/pages/productPage.js








































function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var Page = function(param) {
    var initialProduct = param.product, upSellSkus = param.upSellSkus, initialProductsFromCollection = param.productsFromCollection, sku = param.sku, productUrl = param.productUrl, initialProductsCompleteTheLook = param.productsCompleteTheLook, footerContent = param.footerContent, initialCategory = param.initialCategory, initialBrandInfo = param.brandInfo, initialCollectionInfo = param.collectionInfo, isProductPageHit = param.isProductPageHit;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25, ref26, ref27;
    var language = (0,LanguageProvider.useLanguage)().language;
    var sale = (0,HitProvider.useHit)(!isProductPageHit).sale;
    var ref28;
    var currentSku = (ref28 = sale === null || sale === void 0 ? void 0 : sale.sku) !== null && ref28 !== void 0 ? ref28 : sku;
    var externalContentTimeout = (0,useLoader.useLoader)().externalContentTimeout;
    var ref29 = (0,useProduct.useProduct)(currentSku, productUrl, language, initialProduct), productData = ref29.data;
    if (isProductPageHit && (productData === null || productData === void 0 ? void 0 : (ref = productData.product) === null || ref === void 0 ? void 0 : (ref1 = ref.otherVariants) === null || ref1 === void 0 ? void 0 : ref1.length) > 0) {
        productData.product.otherVariants = [];
    }
    var ref30 = (0,usePrismicBrandInfo/* usePrismicBrandInfo */.yF)(productData === null || productData === void 0 ? void 0 : productData.product.producerId, language, initialBrandInfo), brandInfo = ref30.data;
    var ref31 = (0,usePrismicCollectionInfo/* usePrismicCollectionInfo */.W2)(productData === null || productData === void 0 ? void 0 : (ref2 = productData.product) === null || ref2 === void 0 ? void 0 : ref2.collection.id, language, initialCollectionInfo), collectionInfo = ref31.data;
    if ((productData === null || productData === void 0 ? void 0 : productData.product) && !upSellSkus) {
        upSellSkus = (0,getSkusFromProductLinks/* default */.Z)(productData.product.relatedProducts);
    }
    var ref32 = (0,useProductsBySkus.useProductsBySkus)(upSellSkus, 12, initialProductsCompleteTheLook), productsCompleteTheLook = ref32.data;
    var ref33 = (0,useProductsFromCollection/* useProductsFromCollection */.ie)(productData === null || productData === void 0 ? void 0 : (ref3 = productData.product) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.collection) === null || ref4 === void 0 ? void 0 : ref4.id, 12, initialProductsFromCollection), productsFromCollection = ref33.data;
    var categoryId = (productData === null || productData === void 0 ? void 0 : (ref5 = productData.product) === null || ref5 === void 0 ? void 0 : ref5.category) && (productData === null || productData === void 0 ? void 0 : (ref6 = productData.product) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.category) === null || ref7 === void 0 ? void 0 : ref7.id) !== 2 && (productData === null || productData === void 0 ? void 0 : (ref8 = productData.product) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.category) === null || ref9 === void 0 ? void 0 : ref9.id);
    var ref34 = (0,useCategory/* useCategory */.b5)(categoryId, initialCategory), category = ref34.data;
    var collectionName = (productData === null || productData === void 0 ? void 0 : (ref10 = productData.product) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.collection) === null || ref11 === void 0 ? void 0 : ref11.name) && (0,handleLanguageCharacters.removeSpecificCharactersFromString)({
        string: productData.product.collection.name.toLowerCase().replace(/\s/g, "_").replace(/\//g, "_").replace(/&/g, "_").replace(/(_)\1+/g, "_")
    });
    var categoryUrl = category ? category.url : storeRootCategory_namespaceObject[language.language];
    var productCategory = category ? {
        name: category === null || category === void 0 ? void 0 : category.name,
        url: categoryUrl
    } : null;
    var imagesWithDefaultImage = (0,getDefaultProductImage["default"])(__webpack_require__.g.__appConfig__.pdpDefaultImage, language === null || language === void 0 ? void 0 : language.language, productData);
    if (imagesWithDefaultImage) {
        productData.product.images = imagesWithDefaultImage;
    }
    var translations = {
        seeAll: (0,langLibrary["default"])("see all"),
        popularCategories: (0,langLibrary["default"])("Popular categories"),
        newIn: (0,langLibrary["default"])("New in"),
        allNew: (0,langLibrary["default"])("all new"),
        bestsellers: (0,langLibrary["default"])("Bestsellers"),
        seoDescription: (0,langLibrary["default"])("Default seo description"),
        seoTitle: (0,langLibrary["default"])("Default seo title"),
        fromCollection: (0,langLibrary["default"])("Also from this collection"),
        completeTheLook: (0,langLibrary["default"])("Complete the look"),
        shopAllCollection: (0,langLibrary["default"])("Shop all{collectionName}}", {
            collectionName: productData === null || productData === void 0 ? void 0 : productData.product.collection.name
        })
    };
    var product1 = productData === null || productData === void 0 ? void 0 : productData.product;
    var categoryIdOutlet = (0,isGlobalEnvEnabled["default"])({
        globalEnv: __webpack_require__.g.__appConfig__.categoryOutletId,
        language: language,
        returnValue: true
    });
    var getCategoryNameForGivenCategoryId = (0,useCategoryTree.useCategoryTree)().getCategoryNameForGivenCategoryId;
    var productVisited = (0,useAnalytics4AndCommerceTags["default"])().productVisited;
    var handleSalesmanagoEvent = (0,useSalesmanago["default"])();
    var producerForUrl = productData === null || productData === void 0 ? void 0 : (ref12 = productData.product) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.producer) === null || ref13 === void 0 ? void 0 : ref13.toLowerCase();
    var collectionUrl = producerForUrl ? "".concat(storeRootCategory_namespaceObject[language.language], "/").concat((0,handleLanguageCharacters.removeSpecificCharactersFromString)({
        string: producerForUrl,
        removeSpaces: true
    }), "-").concat(collectionName) : "".concat(storeRootCategory_namespaceObject[language.language], "/").concat((0,handleLanguageCharacters.removeSpecificCharactersFromString)({
        string: productData === null || productData === void 0 ? void 0 : (ref14 = productData.product) === null || ref14 === void 0 ? void 0 : (ref15 = ref14.collection) === null || ref15 === void 0 ? void 0 : ref15.name,
        removeSpaces: true,
        spaceChar: "_"
    }).toLowerCase());
    var firstUpdate = (0,react.useRef)(true);
    var size = useWindowSize_default()();
    var ref35 = (0,react.useState)(null), isMobile = ref35[0], setMobile = ref35[1];
    (0,react.useEffect)(function() {
        var isMobileSize = size.width <= parseInt((0,theme/* default */.Z)().breakpoints.md);
        if (isMobile !== isMobileSize) {
            setMobile(isMobileSize);
        }
    }, [
        size.width
    ]);
    (0,react.useEffect)(function() {
        if (firstUpdate.current === categoryId) {
            return;
        }
        firstUpdate.current = categoryId;
        (productData === null || productData === void 0 ? void 0 : productData.product) && productVisited(productData.product, getCategoryNameForGivenCategoryId(categoryId));
        var _special;
        handleSalesmanagoEvent("OFFER", {
            products: [
                productData === null || productData === void 0 ? void 0 : productData.product.sku
            ],
            value: (_special = productData === null || productData === void 0 ? void 0 : productData.product.price.special) !== null && _special !== void 0 ? _special : productData === null || productData === void 0 ? void 0 : productData.product.price.regular
        });
    });
    var activeProduct = (0,useProductHeadOptions.useProductHeadOptions)().activeProduct;
    var currentProduct = activeProduct ? activeProduct : product1;
    var dataRequiredToHideLoader = (0,react.useMemo)(function() {
        return [
            productData,
            productsCompleteTheLook,
            productsFromCollection
        ];
    }, [
        productData,
        productsCompleteTheLook,
        productsFromCollection
    ]);
    if (productData === null || productData === void 0 ? void 0 : productData.error) {
        return(/*#__PURE__*/ (0,jsx_runtime.jsx)(_error["default"], {
            statusCode: 404
        }));
    }
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MetaTags/* default */.Z, {
                page: dist_MetaTags/* META_TYPE.PRODUCT_PAGE */.Op.PRODUCT_PAGE,
                title: currentProduct === null || currentProduct === void 0 ? void 0 : currentProduct.name,
                description: (currentProduct === null || currentProduct === void 0 ? void 0 : (ref16 = currentProduct.info) === null || ref16 === void 0 ? void 0 : ref16.description) ? product1 === null || product1 === void 0 ? void 0 : (ref17 = product1.info) === null || ref17 === void 0 ? void 0 : ref17.description : "Professional product",
                imageUrl: product1 && product1.image && product1.image.originalSrc,
                url: product1 && product1.name && product1.url,
                sku: product1 === null || product1 === void 0 ? void 0 : product1.sku,
                productRegularPrice: product1 === null || product1 === void 0 ? void 0 : (ref18 = product1.price) === null || ref18 === void 0 ? void 0 : ref18.regular,
                productSpecialPrice: (product1 === null || product1 === void 0 ? void 0 : (ref19 = product1.price) === null || ref19 === void 0 ? void 0 : ref19.special) ? product1 === null || product1 === void 0 ? void 0 : (ref20 = product1.price) === null || ref20 === void 0 ? void 0 : ref20.special : product1 === null || product1 === void 0 ? void 0 : (ref21 = product1.price) === null || ref21 === void 0 ? void 0 : ref21.regular,
                productAvailability: product1 === null || product1 === void 0 ? void 0 : (ref22 = product1.availability) === null || ref22 === void 0 ? void 0 : ref22.stock,
                productBrand: product1 === null || product1 === void 0 ? void 0 : product1.producer,
                productCategory: product1 ? getCategoryNameForGivenCategoryId(product1 === null || product1 === void 0 ? void 0 : (ref23 = product1.category) === null || ref23 === void 0 ? void 0 : ref23.id) : null
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(PageContainer/* default */.Z, {
                footerContent: footerContent,
                dataRequiredToHideLoader: dataRequiredToHideLoader,
                children: [
                    (productData === null || productData === void 0 ? void 0 : productData.product) && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ProductHead, {
                        product: productData === null || productData === void 0 ? void 0 : productData.product,
                        productCategory: productCategory,
                        productFromOutlet: categoryIdOutlet && ((ref24 = productData.product.category.pathIds) === null || ref24 === void 0 ? void 0 : ref24.includes(categoryIdOutlet)),
                        isMobile: isMobile,
                        rootCategories: storeRootCategory_namespaceObject,
                        brandCategories: storeBrandCategory_namespaceObject,
                        isProductPageHit: isProductPageHit
                    }),
                    (productsFromCollection === null || productsFromCollection === void 0 ? void 0 : productsFromCollection.length) > 0 && (productData === null || productData === void 0 ? void 0 : productData.product) && /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionWithConfigurableHeader/* default */.Z, {
                        title: translations.fromCollection,
                        link: {
                            url: collectionUrl,
                            name: translations.shopAllCollection
                        },
                        noSpaceAfterHeader: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardsSlider/* default */.Z, {
                            children: productsFromCollection.map(function(product, index) {
                                if (product.producerId === productData.product.producerId) return(/*#__PURE__*/ (0,jsx_runtime.jsx)(ProductBox/* default */.Z, {
                                    product: product,
                                    colors: []
                                }, index));
                            })
                        })
                    }),
                    (productsCompleteTheLook === null || productsCompleteTheLook === void 0 ? void 0 : productsCompleteTheLook.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionWithConfigurableHeader/* default */.Z, {
                        title: translations.completeTheLook,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardsSlider/* default */.Z, {
                            children: productsCompleteTheLook.map(function(product, index) {
                                /*#__PURE__*/ return (0,jsx_runtime.jsx)(ProductBox/* default */.Z, {
                                    product: product,
                                    colors: []
                                }, index);
                            })
                        })
                    }),
                    brandInfo && !externalContentTimeout && /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionWithConfigurableHeader/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)((Container_default()), {
                            sx: {
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((Box_default()), {
                                    sx: {
                                        width: [
                                            "100%",
                                            null,
                                            "50%"
                                        ]
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BrandInfo/* default */.Z, {
                                        title: brandInfo.title,
                                        description: brandInfo.description,
                                        icon: brandInfo.logo
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((Box_default()), {
                                    sx: {
                                        display: "flex",
                                        justifyContent: "center"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((Box_default()), {
                                        sx: {
                                            width: [
                                                "90%",
                                                null,
                                                "45%"
                                            ],
                                            color: "main",
                                            font: "base"
                                        }
                                    })
                                })
                            ]
                        })
                    }),
                    collectionInfo && !externalContentTimeout && /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionWithConfigurableHeader/* default */.Z, {
                        title: collectionInfo.title,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)((Container_default()), {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((Grid_default()), {
                                    cols: [
                                        1,
                                        null,
                                        3
                                    ],
                                    sx: {
                                        gridRowGap: "s11",
                                        mt: "s11"
                                    },
                                    children: (ref25 = collectionInfo.banners) === null || ref25 === void 0 ? void 0 : ref25.map(function(banner, index) {
                                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(CardWithLabel/* default */.Z, {
                                            name: banner.title,
                                            image: banner.image,
                                            infoOnly: true
                                        }, index);
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((Box_default()), {
                                    sx: {
                                        display: "flex",
                                        justifyContent: "center"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((Box_default()), {
                                        as: "p",
                                        sx: {
                                            width: [
                                                "90%",
                                                null,
                                                "45%"
                                            ],
                                            color: "main",
                                            font: "base",
                                            py: "s12",
                                            a: {
                                                color: "main"
                                            }
                                        },
                                        children: (collectionInfo === null || collectionInfo === void 0 ? void 0 : (ref26 = collectionInfo.text) === null || ref26 === void 0 ? void 0 : ref26.length) > 0 ? prismic_reactjs.RichText.render(collectionInfo.text) : collectionInfo.description
                                    })
                                })
                            ]
                        })
                    })
                ]
            }, productData === null || productData === void 0 ? void 0 : (ref27 = productData.product) === null || ref27 === void 0 ? void 0 : ref27.sku)
        ]
    }));
};
Page.getInitialProps = (function() {
    var _ref = _asyncToGenerator(runtime_default().mark(function _callee(props) {
        var ref, ref36, ref37, ref38, ref39, ref40, ref41, sku, productUrl, language, isProductPageHit, cacheFilePath, ref42, cacheFileExist, filenameCategoryCache, cachedRequest, product, upSellSkus, categoryId, promises, ref43, productsCompleteTheLook, productsFromCollection, brandInfo, collectionInfo, category, result;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ;
                    sku = props.query.productPage;
                    productUrl = isNaN(sku) ? sku : null;
                    language = props.language, isProductPageHit = props.isProductPageHit;
                    if (false) {}
                    return _ctx.abrupt("return", {
                        isProductPageHit: isProductPageHit,
                        sku: sku
                    });
                case 6:
                    cacheFilePath = "".concat(language.language, "/prod/");
                    _ctx.next = 9;
                    return (0,cache.readCacheFile)({
                        cacheFilePath: cacheFilePath,
                        contextRequest: props.req,
                        requestPath: sku
                    });
                case 9:
                    ref42 = _ctx.sent;
                    cacheFileExist = ref42.cacheFileExist;
                    filenameCategoryCache = ref42.filenameCategoryCache;
                    cachedRequest = ref42.cachedRequest;
                    if (!(cacheFileExist && !isProductPageHit)) {
                        _ctx.next = 15;
                        break;
                    }
                    return _ctx.abrupt("return", cachedRequest);
                case 15:
                    _ctx.next = 17;
                    return (0,useProduct.fetcher)(sku, null, language, props.isProductPageHit);
                case 17:
                    product = _ctx.sent;
                    if (isProductPageHit) {
                        product.otherVariants = [];
                    }
                    if (!(product.product === null || product.product && Object.keys(product === null || product === void 0 ? void 0 : product.product).length === 0 && product.product.constructor === Object)) {
                        _ctx.next = 21;
                        break;
                    }
                    return _ctx.abrupt("return", {
                        error: {
                            statusCode: 404
                        }
                    });
                case 21:
                    upSellSkus = (0,getSkusFromProductLinks/* default */.Z)(product === null || product === void 0 ? void 0 : (ref = product.product) === null || ref === void 0 ? void 0 : ref.relatedProducts);
                    categoryId = (product === null || product === void 0 ? void 0 : (ref36 = product.product) === null || ref36 === void 0 ? void 0 : ref36.category.id) !== false && (product === null || product === void 0 ? void 0 : (ref37 = product.product) === null || ref37 === void 0 ? void 0 : ref37.category.id) !== 2 && (product === null || product === void 0 ? void 0 : (ref38 = product.product) === null || ref38 === void 0 ? void 0 : ref38.category.id);
                    promises = [
                        (0,useProductsBySkus.fetcher)({
                            skus: upSellSkus,
                            pageSize: 10,
                            language: language
                        }),
                        (0,useProductsFromCollection/* fetcher */._i)((ref39 = product.product) === null || ref39 === void 0 ? void 0 : ref39.collection.id, 12, language),
                        (0,usePrismicBrandInfo/* fetcher */._i)((ref40 = product.product) === null || ref40 === void 0 ? void 0 : ref40.producerId, language),
                        (0,usePrismicCollectionInfo/* fetcher */._i)((ref41 = product.product) === null || ref41 === void 0 ? void 0 : ref41.collection.id, language)
                    ];
                    if (categoryId) {
                        promises.push((0,useCategory/* fetcher */._i)(categoryId, language).then(function(res) {
                            return res;
                        }));
                    }
                    _ctx.t0 = _slicedToArray;
                    _ctx.next = 28;
                    return Promise.all(promises);
                case 28:
                    _ctx.t1 = _ctx.sent;
                    ref43 = (0, _ctx.t0)(_ctx.t1, 5);
                    productsCompleteTheLook = ref43[0];
                    productsFromCollection = ref43[1];
                    brandInfo = ref43[2];
                    collectionInfo = ref43[3];
                    category = ref43[4];
                    result = {
                        sku: sku,
                        productUrl: productUrl,
                        language: language,
                        product: product,
                        initialCategory: category,
                        upSellSkus: upSellSkus,
                        productsFromCollection: productsFromCollection,
                        productsCompleteTheLook: productsCompleteTheLook,
                        brandInfo: brandInfo,
                        collectionInfo: collectionInfo
                    };
                    if (!(cacheFileExist === false)) {
                        _ctx.next = 39;
                        break;
                    }
                    _ctx.next = 39;
                    return (0,cache.saveCacheFile)({
                        cacheFilePath: cacheFilePath,
                        filenameCategoryCache: filenameCategoryCache,
                        result: result
                    });
                case 39:
                    return _ctx.abrupt("return", result);
                case 40:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function(props) {
        return _ref.apply(this, arguments);
    };
})();
/* harmony default export */ var productPage = (Page);


/***/ })

}]);